export const translations = {
    en: {
        home: {
            banners: [
                {
                    title: "BJ40 PRO",
                    subtitle: "Meet your desires of adventure\non and off-road",
                    buttonText: "Discover More"
                },
                {
                    title: "BJ40 HONOR",
                    subtitle: "Makes Off-road adventures affordable",
                    buttonText: "Discover More"
                },
                {
                    title: "BJ30 HYBRID",
                    subtitle: "Fun and Freedom for the family long drives\non and off-road with Hybrid Power",
                    buttonText: "Discover More"
                },
                {
                    title: "U5 PLUS",
                    subtitle: "The Family Sedan : Cheer for your life.",
                    buttonText: "Discover More"
                },
                {
                    title: "Adventure for Everyone",
                    subtitle: "Engineered for All-terrain.",
                    buttonText: "Discover More"
                }
            ]
        },
        featureCards: {
            offRoadVehicle: "Off-Road Vehicle",
            baicHistory: "BAIC History",
            learnMore: "Learn More"
        },
        serviceCentres: {
            showroomsTitle: "Showrooms",
            serviceCentersTitle: "Service Centers",
            salesDesc: "BAIC Sales has its network spread all across Oman. In most locations, exclusive facilities catering to the sales requirements of customers are available. At major locations, our outlets are now upgraded with global standards for delivering Sales, Spare-parts and Service to customers.",
            serviceDesc: "BAIC Service has its network spread all across Oman. In most locations, exclusive facilities catering to the service requirements of customers are available. At major locations, our outlets are now upgraded with global standards for delivering Sales, Spare-parts and Service to customers.",
            contactDetails: "Contact Details",
            workingTiming: "Working Timing",
            nearestLandmark: "Nearest Landmark",
            map: "Map",
            satellite: "Satellite",
            tollFree: "Toll Free",
            showroom: "Showroom",
            mobile: "Mobile",
            centers: [
                {
                    id: 1,
                    type: 'showroom',
                    name: 'Al Qurum Showroom',
                    address: 'Al Qurum, Muscat',
                    landmark: 'Bahwan Premises, diagonally opposite Qurum City Center, Al Qurum',
                    contacts: ['Toll Free: 80050800', 'Mobile: 79999073'],
                    timing: ['Sat–Thu: 8:30 AM – 1:30 PM, 4:00 PM – 7:00 PM', 'Friday: Closed'],
                    mapUrl: 'https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2794.2595257188273!2d58.492442!3d23.609262!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDM2JzMzLjMiTiA1OMKwMjknMzIuOCJF!5e1!3m2!1sen!2sin!4v1768894154353!5m2!1sen!2sin'
                },
                {
                    id: 2,
                    type: 'showroom',
                    name: 'Suhar Showroom',
                    address: 'Suhar',
                    landmark: 'Al Bahja Street',
                    contacts: ['Toll Free: 80050800', 'Mobile: 95351200'],
                    timing: ['Sat–Thu: 8:30 AM – 1:30 PM, 4:00 PM – 7:00 PM', 'Friday: Closed'],
                    mapUrl: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1422766.226049702!2d55.5305507!3d24.322487!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e8b5d42a5b887a5%3A0x9c40acd375ab9c6f!2sChangan%20Oman%2C%20Sohar!5e1!3m2!1sen!2sin!4v1768894245446!5m2!1sen!2sin'
                },
                {
                    id: 3,
                    type: 'showroom',
                    name: 'Barka',
                    address: 'Barka',
                    landmark: 'Near Lulu Hypermarket, next to Al Madina Insurance office, Barka.',
                    contacts: ['Toll Free: 80050800', 'Showroom: 96629010'],
                    timing: ['Sat–Thu: 8:30 AM – 1:30 PM, 4:00 PM – 7:00 PM', 'Friday: Closed'],
                    mapUrl: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d357502.29312140896!2d57.5742911!3d23.6689047!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e8dc4d30fe70591%3A0x6eb3cc9e189f4da4!2sCHANGAN%20AUTO%20SHOWROOM!5e1!3m2!1sen!2sin!4v1768894287914!5m2!1sen!2sin'
                },
                {
                    id: 4,
                    type: 'showroom',
                    name: 'Nizwa',
                    address: 'Nizwa',
                    landmark: 'Near Al Diyar Hotel and Shell Oman Filling Station',
                    contacts: ['Toll Free: 80050800', 'Showroom: 96628930'],
                    timing: ['Sat–Thu: 8:30 AM – 1:30 PM, 4:00 PM – 7:00 PM', 'Friday: Closed'],
                    mapUrl: 'https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2809.0527555128688!2d57.533035!3d22.905357!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjLCsDU0JzE5LjMiTiA1N8KwMzEnNTguOSJF!5e1!3m2!1sen!2sin!4v1768894343963!5m2!1sen!2sin'
                },
                {
                    id: 5,
                    type: 'showroom',
                    name: 'Ibri',
                    address: 'Ibri',
                    landmark: 'Near National Bank Oman, Ibri',
                    contacts: ['Toll Free: 80050800', 'Showroom: 96628930'],
                    timing: ['Sat–Thu: 8:30 AM – 1:30 PM, 4:00 PM – 7:00 PM', 'Friday: Closed'],
                    mapUrl: 'https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2802.55087923698!2d56.480489999999996!3d23.217218000000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDEzJzAyLjAiTiA1NsKwMjgnNDkuOCJF!5e1!3m2!1sen!2sin!4v1768894382887!5m2!1sen!2sin'
                },
                {
                    id: 6,
                    type: 'showroom',
                    name: 'Sur',
                    address: 'Sur',
                    landmark: 'Near Badr Al Sama Hospital, Sur',
                    contacts: ['Toll Free: 80050800', 'Showroom: 96628920'],
                    timing: ['Sat–Thu: 8:30 AM – 1:30 PM, 4:00 PM – 7:00 PM', 'Friday: Closed'],
                    mapUrl: 'https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2815.9720508015757!2d59.49772300000001!3d22.569!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjLCsDM0JzA4LjQiTiA1OcKwMjknNTEuOCJF!5e1!3m2!1sen!2sin!4v1768894470282!5m2!1sen!2sin'
                },
                {
                    id: 7,
                    type: 'showroom',
                    name: 'Salalah',
                    address: 'Salalah',
                    landmark: 'Sanaiya Area, near Bank Muscat',
                    contacts: ['Toll Free: 80050800', 'Showroom: 96629050'],
                    timing: ['Sat–Thu: 8:30 AM – 1:30 PM, 4:00 PM – 7:00 PM', 'Friday: Closed'],
                    mapUrl: 'https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2915.977539192713!2d54.04372799999999!3d17.018175!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTfCsDAxJzA1LjQiTiA1NMKwMDInMzcuNCJF!5e1!3m2!1sen!2sin!4v1768894509980!5m2!1sen!2sin'
                },
                {
                    id: 101,
                    type: 'service',
                    name: 'Azaiba Service Center',
                    address: 'Azaiba',
                    landmark: 'Near Al Meera Hypermarket, Azaiba',
                    contacts: ['Toll Free: 80050800', 'Mobile: 94589715 / 97440789'],
                    timing: ['Sun-Thu: 7:30 AM-7.00 PM', 'Saturday: 8:30 AM-1 PM, 2.00 PM-5.30 PM', 'FRIDAY: CLOSED'],
                    mapUrl: ""
                },
                {
                    id: 102,
                    type: 'service',
                    name: 'Wadi Kabir Service Center',
                    address: 'Wadi Kabir',
                    landmark: 'Near Nesto Hypermarket, Wadi Kabir',
                    contacts: ['Toll Free: 80050800', 'Mobile: 96580057'],
                    timing: ['Sun-Thu: 7:30 AM-7.00 PM', 'Saturday: 8:30 AM-1 PM, 2.00 PM-5.30 PM', 'FRIDAY: CLOSED'],
                    mapUrl: ""
                },
                {
                    id: 103,
                    type: 'service',
                    name: 'Al Amerat Service Center',
                    address: 'Al Amerat',
                    landmark: 'Lulu Hypermarket, Al Amerat',
                    contacts: ['Toll Free: 80050800'],
                    timing: ['Sun–Thu: 8:30 AM – 7:00 PM', 'Saturday: 8:30 AM – 1:00 PM, 2:00 PM – 5:30 PM', 'Friday: Closed'],
                    mapUrl: ''
                },
                {
                    id: 104,
                    type: 'service',
                    name: 'Mabella Service Center',
                    address: 'Mabella',
                    landmark: 'Al Imar Street, Street No. – 7713',
                    contacts: ['Toll Free: 80050800', 'Mobile: 9533 0380'],
                    timing: ['Sun–Thu: 7:30 AM – 7:00 PM', 'Saturday: 8:30 AM – 1:00 PM, 2:00 PM – 5:30 PM', 'Friday: Closed'],
                    mapUrl: ''
                },
                {
                    id: 105,
                    type: 'service',
                    name: 'Rusayl – Bodyshop',
                    address: 'Rusayl',
                    landmark: 'Near Oriental Ready Mix',
                    contacts: ['Toll Free: 80050800', 'Mobile: 97163035'],
                    timing: ['Sun–Thu: 8:30 AM – 1:00 PM, 2:00 PM – 5:30 PM', 'Friday & Saturday: Closed'],
                    mapUrl: ''
                },
                {
                    id: 106,
                    type: 'service',
                    name: 'Barka Service Center',
                    address: 'Barka',
                    landmark: 'Near Lulu Hypermarket, next to Al Madina Insurance office, Barka.',
                    contacts: ['Toll Free: 80050800', 'Mobile: 9509 4517'],
                    timing: ['Sun–Thu: 8:30 AM – 1:00 PM, 2:00 PM – 5:30 PM', 'Friday & Saturday: Closed'],
                    mapUrl: ''
                },
                {
                    id: 107,
                    type: 'service',
                    name: 'Suhar Service Center',
                    address: 'Suhar',
                    landmark: 'Al Bahja Street',
                    contacts: ['Toll Free: 80050800', 'Mobile: 9400 0961'],
                    timing: ['Sun–Thu: 7:30 AM – 7:00 PM', 'Saturday: 8:30 AM – 1:00 PM, 2:00 PM – 5:30 PM', 'Friday: Closed'],
                    mapUrl: ''
                },
                {
                    id: 108,
                    type: 'service',
                    name: 'Nizwa Service Center',
                    address: 'Nizwa',
                    landmark: 'Near Al Diyar Hotel and Shell Oman Filling Station',
                    contacts: ['Toll Free: 80050800', 'Mobile: 9709 7968'],
                    timing: ['Sun–Thu: 8:30 AM – 1:00 PM, 2:00 PM – 5:30 PM', 'Friday & Saturday: Closed'],
                    mapUrl: ''
                },
                {
                    id: 109,
                    type: 'service',
                    name: 'Ibri Service Center',
                    address: 'Ibri',
                    landmark: 'Near National Bank Oman, Ibri',
                    contacts: ['Toll Free: 80050800', 'Mobile: 9418 9060'],
                    timing: ['Sun–Thu: 8:30 AM – 1:00 PM, 2:00 PM – 5:30 PM', 'Friday & Saturday: Closed'],
                    mapUrl: ''
                },
                {
                    id: 110,
                    type: 'service',
                    name: 'Sur Service Center',
                    address: 'Sur',
                    landmark: 'Near Badr Al Sama Hospital, Sur',
                    contacts: ['Toll Free: 80050800', 'Mobile: 9410 1939'],
                    timing: ['Sun–Thu: 8:30 AM – 1:00 PM, 2:00 PM – 5:30 PM', 'Friday & Saturday: Closed'],
                    mapUrl: ''
                },
                {
                    id: 111,
                    type: 'service',
                    name: 'Duqm Service Center',
                    address: 'Duqm',
                    landmark: 'Near Hashar Roundabout, Nizwa',
                    contacts: ['Toll Free: 80050800'],
                    timing: ['Sun–Thu: 8:30 AM – 1:00 PM, 2:00 PM – 5:30 PM', 'Friday & Saturday: Closed'],
                    mapUrl: ''
                },
                {
                    id: 113,
                    type: 'service',
                    name: 'Maweleh Service Center',
                    address: 'Maweleh',
                    landmark: 'Near Old Vegetable Market, Nizwa road.',
                    contacts: ['Toll Free: 80050800', 'Mobile: 79913319 / 7913 7980'],
                    timing: ['Sun-Thu: 7:30 AM-7.00 PM', 'Saturday: 8:30 AM-1 PM, 2.00 PM-5.30 PM', 'FRIDAY: CLOSED'],
                    mapUrl: ''
                },
                {
                    id: 112,
                    type: 'service',
                    name: 'Salalah Service Center',
                    address: 'Salalah',
                    landmark: 'Sanaiya Area, near Bank Muscat',
                    contacts: ['Toll Free: 80050800', 'Mobile: 9533 4250'],
                    timing: ['Sun–Thu: 8:30 AM – 1:00 PM, 2:00 PM – 5:30 PM', 'Friday & Saturday: Closed'],
                    mapUrl: ''
                }
            ],
        },
        modelShowcase: {
            categories: {
                offRoad: "Off-Road",
                sedan: "Sedan"
            },
            models: {
                bj30: "BJ30 Hybrid",
                bj40Honor: "BJ40 Honor",
                bj40Pro: "BJ40 PRO",
                u5Plus: "U5 PLUS"
            },
            view360: "360° View"
        },
        models: {
            title: "Our Models",
            subtitle: "Explore the complete BAIC lineup",
            all: "All",
            offRoad: "Off-road",
            suv: "SUV",
            sedan: "Sedan",
            viewDetails: "View Details",
            testDrive: "Test Drive",
            startingAt: "Starting at",
            list: [
                {
                    name: 'BJ80',
                    category: 'Off-road',
                    image: 'https://images.pexels.com/photos/35290260/pexels-photo-35290260.jpeg',
                    price: 'Starting at $65,000',
                    specs: { power: '320 HP', fuel: 'Hybrid', seats: '7 Seats', drive: '4WD' },
                },
                {
                    name: 'BJ60',
                    category: 'Off-road',
                    image: 'https://images.pexels.com/photos/104401/pexels-photo-104401.jpeg',
                    price: 'Starting at $52,000',
                    specs: { power: '280 HP', fuel: 'Petrol', seats: '5 Seats', drive: '4WD' },
                },
                {
                    name: 'BJ40 C',
                    category: 'Off-road',
                    image: 'https://images.pexels.com/photos/215528/pexels-photo-215528.jpeg',
                    price: 'Starting at $45,000',
                    specs: { power: '250 HP', fuel: 'Diesel', seats: '5 Seats', drive: '4WD' },
                },
                {
                    name: 'X55',
                    category: 'SUV',
                    image: 'https://images.pexels.com/photos/35290260/pexels-photo-35290260.jpeg',
                    price: 'Starting at $35,000',
                    specs: { power: '190 HP', fuel: 'Petrol', seats: '5 Seats', drive: 'FWD' },
                },
                {
                    name: 'X7',
                    category: 'SUV',
                    image: 'https://images.pexels.com/photos/104401/pexels-photo-104401.jpeg',
                    price: 'Starting at $42,000',
                    specs: { power: '220 HP', fuel: 'Hybrid', seats: '7 Seats', drive: 'AWD' },
                },
                {
                    name: 'D50',
                    category: 'Sedan',
                    image: 'https://images.pexels.com/photos/70912/pexels-photo-70912.jpeg',
                    price: 'Starting at $28,000',
                    specs: { power: '160 HP', fuel: 'Petrol', seats: '5 Seats', drive: 'FWD' },
                },
            ],
            bj30: {
                hero: {
                    // title: "Unleash Adventure",
                    // subtitle: "With Hybrid Power"
                    title: "",
                    subtitle: "Fun and Freedom for the family long \n drives on and off-road with Hybrid Power",

                },
                intro: {
                    title: "Start Your Adventure",
                    desc: "The all-new BJ30 combines rugged off-road capability with modern urban sophistication. With its 'Magic Core' hybrid power and intelligent terrain system, it's ready for any journey.",
                    stats: {
                        turbo: { value: "1.5 Turbo", label: "Hybrid Engine" },
                        hp: { value: "403", label: "HP (Combined)" },
                        torque: { value: "685", label: "Nm Torque" },
                        accel: { value: "6.6s", label: "0-100 km/h" }
                    }
                },
                atsPointsDesktop: [
                    { id: "roof", x: 52.0, y: 32.0, label: "High load bearing roof" },
                    { id: "hardTop", x: 70.0, y: 34.0, label: "L-type suspended hard top" },
                    { id: "mark", x: 69.0, y: 42.0, label: "Personality mark Reserved place" },
                    { id: "lamp", x: 20.0, y: 48.0, label: "Personality ritual feeling round eyebrow lamp" },
                    { id: "scratch", x: 40.0, y: 62.0, label: "Scratch-proof design" },
                    { id: "approach", x: 22.0, y: 70.0, label: "°Approach Angle 25" },
                    { id: "departure", x: 76.0, y: 70.0, label: "Departure Angle 30" }
                ],
                atsPointsMobile: [
                    { id: "roof", x: 52.0, y: 32.0, label: "High load bearing roof" },
                    { id: "hardTop", x: 73.0, y: 34.0, label: "L-type suspended hard top" },
                    { id: "mark", x: 82.0, y: 38.0, label: "Personality mark Reserved place" },
                    { id: "lamp", x: 22.0, y: 48.0, label: "Personality ritual feeling round eyebrow lamp" },
                    { id: "scratch", x: 40.0, y: 72.0, label: "Scratch-proof design" },
                    { id: "approach", x: 15.0, y: 85.0, label: "°Approach Angle 25" },
                    { id: "departure", x: 86.0, y: 85.0, label: "Departure Angle 30" }
                ],
                exterior: {
                    face: { title: "Family Face", desc: "Signature 5-hole grille reinterpreted for the electric era." },
                    led: { title: "Intelligent LED", desc: "Matrix LED headlights with welcoming animation." },
                    rear: { title: "Powerful Stance", desc: "Bold rear design with vertical tail lights." }
                },
                interior: {
                    tag: "Smart Cabin",
                    title: "Immersive Tech",
                    dashboard: "14.6-inch Center Screen + 10.25-inch Cluster",
                    features: {
                        gear: { title: "E-Gear Shift", desc: "Aviation-style electronic gear shifter for precise control." },
                        light: { title: "Ambient Light", desc: "Multi-color ambient lighting that adapts to your mood." },
                        space: { title: "Flexible Space", desc: "Versatile seating configurations for maximum utility." }
                    }
                },
                performance: {
                    tag: "Deep Hybrid",
                    title: "Magic Core Power",
                    desc: "The specialized hybrid engine delivers robust performance and exceptional efficiency. Seamlessly switch between electric and gas modes for optimal range and power.",
                    features: ["High Thermal Efficiency", "Intelligent Energy Management", "Smooth Acceleration"]
                },
                ats: {
                    title: "All-Terrain Control System (ATS)",
                    desc: "ATS can automatically optimize the vehicle's various control systems so the vehicle can adapt to various terrains."
                },
                safety: {
                    tag: "Robust Safety Body",
                    desc: "Body structure optimization and safety design technology application ensure the car body structure remains undeformed and keeps free from distortion. Front end 3-stage energy absorption box structure ensures passenger bin robust and reliable even in collision.",
                    stats: {
                        steel: { value: "63.4 %", label: "High Strength Steel" },
                        stiffness: { value: "25420 Nm", label: "Max Torsional Stiffness" },
                        positions: { value: "20 Positions", label: "Thermoformed Steel" }
                    }
                },
                specs: {
                    tag: "Technical Data",
                    title: "Specifications",
                    items: {
                        engine: { label: "Engine", value: "1.5 Turbo", sub: "Hybrid Engine" },
                        transmission: { label: "Transmission", value: "2 DHT" },
                        power: { label: "Net HP", value: "403 HP" },
                        torque: { label: "Max Torque", value: "685 Nm" },
                        drive: { label: "Drive Mode", value: "AWD", sub: "Real-time" },
                        ground: { label: "Ground Clearance", value: "215 mm" },
                        approach: { label: "Approach Angle", value: "24.5", sub: "Degree" },
                        departure: { label: "Departure Angle", value: "30", sub: "Degree" }
                    }
                },
                footer: {
                    title: "Ready to Experience BJ30?",
                    desc: "Fun and Free for Family Long Trips Off-Road and On-Road with Hybrid Power",
                    btn: "Book Test Drive"
                }
            },
            bj40Plus: {
                hero: {
                    title: "BJ40 HONOR",
                    // subtitle: "THE LEGEND IS BACK"
                    subtitle: "Makes Off-road adventures affordable"
                },
                sections: {
                    smartCabin: { tag: "Smart Cabin", title: "Technological Innovation" },
                    interior: { title: "Refined Interior", desc: "A complete departure from the rugged exterior, the interior offers soft-touch materials, ambient lighting, and ergonomic seats for long-distance comfort." },
                    steering: { title: "Multifunction Control", desc: "Leather-wrapped steering wheel with integrated controls for audio, cruise control, and calls, putting everything at your fingertips." },
                    gear: { title: "Precision Shifting", desc: "8-Speed Automatic Transmission ensures smooth power delivery and optimal efficiency in city driving or off-road adventures." },
                    safety: { tag: "Safety", title: "Comprehensive Protection" },
                    performance: { tag: "Performance", title: "Technical Specifications" },
                    footer: { title: "Start the Engine", desc: "Experience the BJ40 Plus first-hand. Book your test drive today.", btn: "Book Test Drive" }
                },
                specs: [
                    { label: 'Engine', value: '2.0L TURBO', sub: 'Engine' },
                    { label: 'Transmission', value: '8AT', sub: '' },
                    { label: 'Net HP', value: '215 HP', sub: '' },
                    { label: 'Max Torque', value: '380 Nm', sub: '' },
                    { label: 'Drive Mode', value: '4WD', sub: '' },
                    { label: 'Ground Clearance', value: '210 mm', sub: '' },
                    { label: 'Approach Angle', value: '37', sub: 'Degree' },
                    { label: 'Departure Angle', value: '31', sub: 'Degree' }
                ],
                features: [
                    {
                        title: "Bold Design with Urban Edge",
                        desc: "Where rugged character meets refined style."
                    },
                    {
                        title: "Light-Ring LED Signature Showcasing a Bold Character",
                        desc: "Nearly 200 exterior LED light sources form a distinctive \"disconnected\" light strip design"
                    },
                    {
                        title: "Hidden Details That Reveal Mechanical Beauty",
                        desc: "Exposed hinges, a three-part opening body, and an independently opening trunk window combine to offer flexible movement and a bold, adaptable design."
                    },
                    {
                        title: "Smart Interior Technology That Elevates Every Drive",
                        desc: "Equipped with a 12.3-inch LCD digital dashboard and a 10-inch center touchscreen for seamless control."
                    },
                    {
                        title: "Multi-Colour Ambient Lighting That Matches Your Mood",
                        desc: "Choose from 256 ambient light colours, including five recommended shades — red, green, ice blue, white, and orange. Enjoy three lighting modes: single-colour static, single-colour breathing, and multi-colour breathing."
                    },
                    {
                        title: "Stylish Electronic Gear Lever for an Enhanced Driving Experience",
                        desc: "Designed with an integrated gear display, functional lighting, and backlit guidance. Automatically shifts to Park when the engine is turned off or the driver leaves the vehicle, enhancing safety and preventing unwanted movement."
                    },
                    {
                        title: "Safety You Can Trust — Anywhere",
                        desc: "ESP plus eight core safety technologies deliver confidence for both urban driving and off-road adventures."
                    },
                    {
                        title: "Non-Load-Bearing 3D Protective Body",
                        desc: "High-strength roll cage, reinforced joint structure, and integrated molded B-pillar. The static roof pressure test exceeds regulatory standards by over 62.2%. Designed for efficient energy absorption while remaining lightweight, capable of absorbing up to 23% of crash energy."
                    },
                    {
                        title: "Excellent Passing Ability",
                        desc: [
                            "Approach angle 37°",
                            "Departure angle 31°",
                            "Ramp angle 23°",
                            "Maximum fording depth > 600mm",
                            "Maximum trench-crossing width 500mm",
                            "Roadblock-crossing height 350mm"
                        ]
                    }
                ]
            },
            bj40Pro: {
                hero: {
                    title: "BJ40 PRO",
                    // subtitle: "Dare to Explore"
                    subtitle: "Meet your desires of adventure\non and off-road"
                },
                sections: {
                    design: { title: "Dominating Design", classic: { title: "Classic Heritage", desc: "Featuring the iconic 5-hole grille and chrome accents defining the BJ40 legacy. Vertical windshield and detachable roof create an unmatched rugged open-air experience." }, stance: { title: "All-Terrain Stance", desc: "Massive 20-inch alloy wheels and high ground clearance ensure you can conquer any obstacle. The robust body structure is designed for maximum durability in the harshest conditions." } },
                    splitTailDoor: { title: "Split Tail Door", desc: "With damping, beautiful and convenient features, the upper and lower sectional design enhances the practicality of the tail door." },
                    power: { title: "Unstoppable Power", engine: { title: "2.0L Turbo", desc: "Generates net HP 231 and 386 Nm of torque to conquer any trail." }, chassis: { title: "Professional Chassis", desc: "Non-load bearing body with independent front suspension for superior off-road handling." } },
                    partTime4WD: { title: "Part-time 4WD System", desc: "Provide the timely four-wheel drive system, support electronic knob switching, including four modes of 2H, 4H, 4L and 4A to meet different driving needs." },
                    cageBody: { title: "Cage Body", desc: "Military-grade cage body design can effectively reduce collision deformation; The application ratio of the thermal forming steel is 79.8%; The lightweight coefficient is 4.34." },
                    techTrim: { title: "Technology Trim Molding", desc: "Top broad vision, wide comfortable space." },
                    skylight: { title: "Large Panoramic Skylight", desc: "Intelligent switch, to enjoy transparent driving experience." },
                    trunkSpace: { title: "Large Trunk Space", desc: "The rear seat features a one-button fold-down function, effortlessly converting into a flat trunk space to accommodate large items with ease. Whether for travel essentials or leisurely reclining, it offers seamless convenience." },
                    interior: { tag: "First Class Cabin", title: "Technology & Comfort" },
                    gallery: { title: "Lifestyle Gallery" },
                    specs: { tag: "Technical Data", title: "Specifications" },
                    footer: { title: "Ready to go Pro?", desc: "Experience the ultimate off-road capability.", btn: "Book Test Drive" }
                },
                specs: [
                    { label: 'Engine', value: '2.0L Turbo', sub: 'Engine' },
                    { label: 'Transmission', value: '8AT', sub: '' },
                    { label: 'Net HP', value: '231 HP', sub: '' },
                    { label: 'Max Torque', value: '386 Nm', sub: '' },
                    { label: 'Drive Mode', value: '4WD', sub: '' },
                    { label: 'Ground Clearance', value: '220 mm', sub: '' },
                    { label: 'Approach Angle', value: '37', sub: 'Degree' },
                    { label: 'Departure Angle', value: '31', sub: 'Degree' }
                ]
            },
            u5Plus: {
                hero: {
                    title: "U5 PLUS",
                    // subtitle: "Modern Aesthetics Meet Intelligent Technology"
                    subtitle: "The Family Sedan : Cheer for your life."
                },
                sections: {
                    exterior: {
                        title: "Exterior Design", subtitle: "Where Classic Meets Modern Elegance", desc: "The BAIC U5 PLUS features a sleek and modern exterior design characterized by its aerodynamic lines and bold stance. It features a striking front grille that gives it a confident and modern look, complemented by sharp LED headlights that enhance visibility and style.",
                        items: [
                            { title: "LED Headlights", desc: "Designed to provide superior illumination, improved visibility, and modern aesthetics, making them a standout feature of the vehicle. This powerful lighting helps to better illuminate the road ahead." },
                            { title: "Front Grille", desc: "The U5 front grille features a modern and attractive design that complements the vehicle's bold and dynamic exterior. With its distinctive pattern, it adds a touch of sophistication and elegance to the front fascia." },
                            { title: "LED Taillights", desc: "The U5 taillights provide bright and clear illumination, ensuring the vehicle is clearly seen by other drivers, especially in low-light conditions and bad weather. High emission enhances safety by making the vehicle more visible." },
                            { title: "16-inch Alloy Wheels", desc: "The 16-inch alloy wheels feature a modern design that complements the U5's exterior styling, adding a touch of sophistication to its sleek look and enhancing the vehicle's visual appeal." }
                        ]
                    },
                    safety: {
                        tag: "Safety", title: "Built with Ultra-High Strength Safety Cage", desc: "Built with ultra-high strength thermoformed steel rated up to 1500 MPa, with 50% of the body structure made of high-strength steel for enhanced safety.",
                        items: [
                            { title: "ABS + EBD + EBA", desc: "The U5 is equipped with advanced safety technologies to enhance driver and passenger protection. Among these features are ABS, EBD, and EBA, each playing a crucial role in maintaining control and stability during various driving conditions." },
                            { title: "Airbags", desc: "The BAIC U5 PLUS is equipped with dual front airbags for both the driver and front passenger and are a key element of the vehicle's safety system, designed to protect occupants in the event of a collision." }
                        ]
                    },
                    interior: {
                        tag: "Interior", title: "First Class Comfort in Every Journey", desc: "The BAIC U5 PLUS interior design offers a blend of modern technology and comfort, featuring a spacious cabin with high-quality materials and carefully considered design.",
                        items: [
                            { title: "12.3-inch Control Screen", desc: "The U5 is equipped with a modern 12.3-inch control screen, which is the core of advanced in-car technology. This large high-resolution screen integrates seamlessly with the vehicle's dashboard, providing both functionality and modern aesthetics." },
                            { title: "7-inch LCD Meter", desc: "It is an advanced digital display that improves the driving experience by providing clear and timely information about the vehicle's performance and status, allowing the driver to quickly and easily access important information." }
                        ]
                    },
                    specs: { tag: "Technical Data", title: "Specifications" },
                    footer: { title: "Drive Smart", desc: "Discover the perfect sedan for the modern family.", btn: "Book Test Drive" }
                },
                specs: [
                    { label: 'Engine', value: '1.5L', sub: 'CVT' },
                    { label: 'Net HP', value: '103 HP' },
                    { label: 'Max Torque', value: '142 Nm', sub: '@ 3800-4800 rpm' },
                    { label: 'Transmission', value: 'CVT', sub: 'Continuously Variable' },
                    { label: 'Dimensions', value: '4660 mm', sub: 'Length' },
                    { label: 'Wheelbase', value: '2670 mm', sub: 'Spacious Cabin' },
                    { label: 'Fuel Consumption', value: '5.7 L', sub: 'per 100 km' },
                    { label: 'Safety', value: '5 Stars', sub: 'C-NCAP Rating' }
                ]
            }
        },
        about: {
            title: "About BAIC",
            subtitle: "Building vehicles that inspire, innovate, and endure for over six decades",
            stats: [
                { value: '60+', label: 'Years of Excellence' },
                { value: '80+', label: 'Countries Worldwide' },
                { value: '100K+', label: 'Employees' },
                { value: 'Top 200', label: 'Fortune Global 500' },
            ],
            missionTitle: "Our Mission",
            missionText: "To create innovative, sustainable, and high-quality vehicles that enhance the lives of our customers worldwide. We are committed to excellence in design, engineering, and customer service, while leading the automotive industry's transition to a sustainable future.",
            visionTitle: "Our Vision",
            visionText: "To be a global leader in smart, connected, and sustainable mobility solutions. We envision a future where our vehicles not only transport people but also contribute to cleaner cities, safer roads, and a more connected world.",
            timelineTitle: "Our Journey",
            timeline: [
                { year: '1958', event: 'BAIC Founded', description: 'Established as Beijing Automobile Works' },
                { year: '1984', event: 'First Joint Venture', description: 'Partnership with AMC to produce the Cherokee' },
                { year: '2010', event: 'BAIC Group Formed', description: 'Restructured into modern corporate entity' },
                { year: '2018', event: 'Global Expansion', description: 'Entered 50+ international markets' },
                { year: '2023', event: 'Electric Future', description: 'Launched comprehensive EV lineup' },
            ]
        },
        overview: {
            whoWeAreTitle: "Who We Are",
            statsGrid: [
                { val: "1958", label: "Founded In", pos: "bottom" },
                { val: "TOP 5", label: "Chinese Automotive Groups", pos: "top" },
                { val: "34 M", label: "Yield", pos: "bottom" },
                { val: "480 B", label: "Operating Revenue", pos: "top" },
                { val: "353.68 B", label: "Brand Value", pos: "bottom" },
                { val: "192", label: "Fortune Global 500", pos: "top" },
                { val: "9.98%", label: "Shares in Daimler AG", pos: "bottom" },
            ],
            awardsTitle: "Awards",
            awardsText: "Through over 60 years of development, BAIC has accumulated extensive experience in automotive R&D, and achieved many awards in areas like technology patents, powertrain, chassis, body structure, intelligent driving, cabin control, health and safety, engineering materials, quality and reputation, receiving unanimous praise from authoritative institutions.",
            topGearTitle: "Top Gear",
            topGearText: "BAIC X55 has once again been awarded the '2023 Readers' Choice Award' by Top Gear, marking the second time in a year that the BAIC X55 has taken the top podium in the South African automotive industry.",
            productionBases: [
                {
                    title: "BEIJING FACTORY",
                    image: "/assets/images/about/overview/new/BEIJING.webp",
                    stats: [
                        { label: "Production Start Time", value: "2015" },
                        { label: "Land Area", value: "540,000 sqm" },
                        { label: "Planned Capacity", value: "100,000 units / year" },
                        { label: "Models In Production", value: "BJ40 / F40 / BJ60 / BJ80" }
                    ]
                },
                {
                    title: "ZHENJIANG FACTORY",
                    image: "/assets/images/about/overview/new/ZHENJIANG.webp",
                    stats: [
                        { label: "Production Start Time", value: "2013" },
                        { label: "Land Area", value: "400,000 sqm" },
                        { label: "Planned Capacity", value: "150,000 units / year" },
                        { label: "Models In Production", value: "BJ30" }
                    ]
                }
            ]
        },
        history: {
            title: "History",
            pageTitle: "BAIC",
            timeline: [
                { year: '2022', title: 'Selected in Fortune Global 500 for ten years consecutively', image: '/assets/images/about/history/fortune500.jpeg' },
                { year: '2021', title: 'BAIC licensed the technology and relevant intellectual property of BE21 platform structure to Steyr USA LLC.', image: '/assets/images/about/history/baic-licensed.jpeg' },
                { year: '2020', title: 'Foton deepened cooperation with Daimler, and the localization of Mercedes-Benz Heavy trucks was officially landed.', image: '/assets/images/about/history/foton-deepened.png' },
                { year: '2018', title: 'BAIC GROUP and MAGNA signed a strategic cooperation agreement to establish a joint venture and build up a high-end BEV R&D and manufacturing base.', image: '/assets/images/about/history/magna.jpeg' },
                { year: '2017', title: 'BJ80 used again as the president\'s vehicle at the military parade to mark the 90th Anniversary of PLA.', image: '/assets/images/about/history/military-parade.jpeg' },
                { year: '2016', title: 'A 35% stake in Fujian Benz was acquired.', image: '/assets/images/about/history/benz.jpeg' },
                { year: '2013', title: 'BAIC INTL was officially established.', image: '/assets/images/about/history/baic-intl.jpeg' },
                { year: '2010', title: '100% of Inalfa\'s shares were successfully acquired.', image: '/assets/images/about/history/inalfa.jpeg' },
                { year: '2009', title: 'BAIC Group has successfully acquired the intellectual property rights of Sweden\'s Saab.', image: '/assets/images/about/history/saab.jpeg' },
                { year: '2003', title: 'BAIC Group and DaimlerChrysler signed a strategic cooperation framework agreement.', image: '/assets/images/about/history/2003.jpeg' },
                { year: '2002', title: 'BAIC Group and Hyundai Motor Company signed a comprehensive strategic cooperation.', image: '/assets/images/about/history/2002.jpeg' },
                { year: '1996', title: 'Foton Motor Co.,Ltd. was established, which ranks first in the world in terms of commercial vehicle sales.', image: '/assets/images/about/history/1996.jpeg' },
                { year: '1983', title: 'Beijing Jeep Joint venture, the first Sino-foreign joint venture for the complete vehicle manufacturing was established.', image: '/assets/images/about/history/1983.jpeg' },
                { year: '1966', title: 'BJ212 off-road vehicle independently developed by BAIC was officially put into production.', image: '/assets/images/about/history/1966.jpeg' },
                { year: '1958', title: '"Jinggangshan" was born as BAIC\'s first sedan.', image: '/assets/images/about/history/1958.jpeg' }
            ]
        },
        vision: {
            title: "VISION",
            subtitle: "Brand Vision",
            banners: [
                {
                    subtitle: 'Brand Positioning',
                    title: 'Making Life Brighter',
                },
                {
                    subtitle: 'Brand Slogan',
                    title: 'Always be with you',
                },
                {
                    subtitle: 'Core Value',
                    title: 'Reliable',
                },
                {
                    subtitle: 'Brand Tonality',
                    title: 'Caring Confident Characteristic',
                }
            ]
        },
        ggs: {
            title: "Gulf Great Sands",
            subtitle: "Gulf Great Sands LLC – Official Distributor of BAIC in Oman",
            p1: "Gulf Great Sands LLC was established in 2016 in Oman and has built a strong reputation for supporting the growth and development of industries across the country. Founded with a passion for excellence and a forward-looking vision, the company continues to evolve through innovation, reliability, and customer-focused solutions.",
            p2: "Gulf Great Sands LLC specializes in automotive passenger vehicles and commercial vehicle solutions, delivering dependable mobility for diverse business needs. As the official distributor of BAIC and Foton in Oman, we provide a comprehensive range of vehicles backed by global expertise, advanced technology, and trusted aftersales support—ensuring lasting value for our customers.",
            vision: {
                title: "Vision",
                desc: "\"A globally recognized business group creating customers for life.\""
            },
            mission: {
                title: "Mission",
                desc: "\"Diversify and innovatively deliver world-class products and services, through empowered employees by creating value for our stakeholders.\""
            },
            values: [
                {
                    title: "Integrity",
                    desc: "We uphold the highest standards of honesty and ethical principles in every action."
                },
                {
                    title: "Ownership",
                    desc: "We take personal responsibility for our actions and detailed attention to our customers' needs."
                },
                {
                    title: "Passion",
                    desc: "We are fueled by an intense desire to achieve, grow, and deliver excellence."
                },
                {
                    title: "Excellence",
                    desc: "We tirelessly strive to exceed expectations and set new benchmarks in quality."
                }
            ]
        },
        afterSales: {
            integrity: {
                title: "Integrity",
                desc: "Original spare parts and transparent and reasonable price"
            },
            warm: {
                title: "Warm",
                desc: "Convenient service service dealers and quick repair and maintenance"
            },
            care: {
                title: "Care",
                desc: "Focus on customer needs and dedicated after-sales service"
            },
            professional: {
                title: "Professional",
                desc: "Advanced facilities and professional service team"
            }
        },
        careers: {
            hero: {
                title: "CAREERS",
                subtitle: "Shape the future of automotive technology with us."
            },
            generalApp: {
                title: "General Application",
                desc: "Don't see a specific role that fits? Submit your general application here, and we'll contact you when a suitable position opens up."
            },
            form: {
                title: "Title",
                firstName: "First Name",
                lastName: "Last Name",
                email: "Email",
                phone: "Phone Number",
                nationality: "Country",
                position: "Position of Interest",
                cv: "Upload CV (PDF/DOC, Max 5MB)",
                chooseFile: "Choose File",
                noFile: "No file chosen",
                message: "Cover Letter / Message",
                submit: "Submit Application",
                submitting: "Submitting...",
                placeholders: {
                    select: "Select",
                    firstName: "First Name",
                    lastName: "Last Name",
                    email: "email@example.com",
                    phone: "50 123 4567",
                    nationality: "Select Nationality",
                    position: "e.g. Sales Executive",
                    message: "Tell us why you'd be a great fit..."
                },
                options: {
                    mr: "Mr.",
                    ms: "Ms.",
                    mrs: "Mrs.",
                    uae: "UAE",
                    other: "Other"
                }
            },
            whyJoin: {
                title: "Why Join BAIC?",
                growth: {
                    title: "Growth Opportunities",
                    desc: "We invest in our people. From training programs to mentorship, we help you build a career, not just a job."
                },
                innovation: {
                    title: "Innovation",
                    desc: "Work with cutting-edge automotive technologies and be part of a brand that defines the future of mobility."
                },
                culture: {
                    title: "Inclusive Culture",
                    desc: "Join a diverse team where every voice matters. We believe in collaboration, respect, and shared success."
                }
            }
        },
        common: {
            threeSixtyView: "360° View",
            capitalBeautyRedefined: "CAPITAL BEAUTY REDEFINED",
            offRoadVehicle: "OFF-ROAD VEHICLE",
        },
        nextSteps: {
            title: "your next steps",
            requestBrochure: "request brochure",
            findShowroom: "find a showroom",
            bookTestDrive: "book a test drive",
            requestQuote: "request quote",
            callTollFree: "call toll free",
            whatsapp: "get us on whatsapp"
        },
        nav: {
            models: 'Models',
            history: 'History',
            about: 'About',
            newsroom: 'Newsroom',
            connect: 'Connect',
            service: 'Service',
            gallery: 'Gallery',
            worldwide: 'Worldwide',
            testDrive: 'Test Drive',
            explore: 'Explore More',
            all: 'ALL',
            offRoad: 'Off-Road',
            suv: 'SUV',
            sedan: 'Sedan',
            power: 'POWER',
            torque: 'TORQUE',
            wheelbase: 'WHEELBASE',
            showrooms_service: 'Showrooms & Service',
            requestQuote: 'Request a Quote',
            bookTestDrive: 'Book a Test Drive',
            requestCatalogue: 'REQUEST BROCHURE',
            categories: 'Categories',
            baicHistory: 'BAIC History',
            offRoadHistory: 'Off-Road',
            baicAbout: 'BAIC',
            ggs: 'GGS',
            vision: 'Vision',
            afterSales: 'After-Sales Service',
            contactUs: 'Contact Us',
            careers: 'Careers',
            showroom: 'Showroom',
            serviceCenter: 'Service Center'
        },
        quickLinks: {
            title: "Quick links",
            contact: "Contact",
            testDrive: "Test drive",
            service: "Service",
            careers: "Careers"
        },
        footer: {
            companyInfo: 'Official Distributor in Oman',
            quickLinks: 'Quick Links',
            services: 'Services',
            contactUs: 'Contact Us',
            disclaimer: 'Disclaimer: Customers should not treat images as exact representation. The vehicles and features shown may vary from the actual models available in your region. Specifications and equipment are subject to change without notice.',
            rights: 'All rights reserved.',
            links: {
                models: 'Models',
                history: 'History',
                aboutBaic: 'About BAIC',
                ggs: 'Gulf Great Sands',
                vision: 'Vision',
                afterSales: 'After-Sales Service',
                careers: 'Careers',
                contact: 'Contact',
                privacyPolicy: 'Privacy Policy',
                termsConditions: 'Terms & Conditions',
                showroom: 'Showroom',
                serviceCenter: 'Service Center',
                bookService: 'Book Service',
                // warranty: 'Warranty'
            },
            contact: {
                call: 'Call',
                whatsapp: 'WhatsApp',
                address: 'Post Box 1642, P.C 131, Al Qurum, Muscat, Sultanate of Oman'
            }
        },
        testDrive: {
            hero: {
                subtitle: "Experience Excellence",
                title: "Test Drive",
                desc: "Discover the exceptional performance and comfort of BAIC vehicles. Book your exclusive test drive experience today."
            },
            steps: {
                step1: { number: "01", title: "Select Model", desc: "Choose your preferred vehicle", sedan: "Sedan", suv: "Off Road" },
                step2: { number: "02", title: "Your Details", desc: "Fill in your contact information" }
            },
            form: {
                title: "Title",
                firstName: "First Name",
                lastName: "Last Name",
                email: "Email Address",
                phone: "Contact Number",
                location: "Your Location",
                date: "Preferred Date",
                time: "Preferred Time",
                message: "Message",
                privacy: "I agree to the privacy statement and understand how my personal data will be processed.",
                submit: "Submit",
                placeholders: {
                    selectTitle: "Mr",
                    phone: "Eg. 12345678",
                    time: "Anytime",
                    pickDate: "Pick a date"
                },
                timeOptions: {
                    anytime: "Anytime",
                    morning: "Morning",
                    afternoon: "Afternoon",
                    evening: "Evening"
                }
            },
            bookNow: "Book Now"
        },
        offRoad: {
            banner: { subtitle: "History", title: "Off-Road" },
            engineering: {
                title: "Engineering Verification Ability",
                p1: "Constructed complete verification systems covering components, systems, and whole vehicles, with CNAS certification obtained. Our professional trial production workshop features a comprehensive verification process, producing up to 300 trial types and mock-up prototypes annually.",
                p2: "Our big data intelligent analysis platform enables rapid and accurate extraction of valuable information from massive data, successfully applied across various vehicle research and development processes."
            },
            production: {
                title: "Vehicle Production Ability",
                desc: "The off-road vehicle factory has an overall construction area of 346,000 square meters and an annual production capacity of 100,000 vehicles, and won the National Green Factory, \"China's Best Factory Digital Competition Excellence Award\"."
            },
            reliability: {
                title: "High Designed Reliability",
                desc: "The off-road vehicle factory has also developed 28 methods for analyzing and extracting load spectra under limit and typical working conditions, combining dynamic and static loads. Additionally, it has innovated 35 high-reliability structures, establishing virtual and physical tests using a multi-level test platform. Basic off-road vehicle base tests have significantly increased the average mileage between failures from 1,200 km to 7,536 km."
            },
            timeline: {
                t1: "The Beginning", t2: "BJ212 Launch", t3: "Evolution", t4: "New Era", t5: "Innovation", t6: "Global Stage", t7: "Expansion", t8: "Modernization", t9: "BJ40 Launch", t10: "Future Forward"
            }
        },
        innovation: {
            hero: {
                title: "Innovation",
                subtitle: "Driving the future with cutting-edge technology and sustainable solutions"
            },

            grid: {
                title: "Our Innovations",
                desc: "BAIC is at the forefront of automotive innovation, developing technologies that redefine mobility and sustainability.",
                items: [
                    { title: "Electric Powertrain", desc: "Next-generation electric and hybrid powertrains delivering exceptional performance with zero emissions." },
                    { title: "Advanced Safety", desc: "Comprehensive safety systems including autonomous emergency braking, lane keeping assist, and 360° monitoring." },
                    { title: "AI Integration", desc: "Artificial intelligence-powered driving assistance and predictive maintenance for enhanced reliability." },
                    { title: "Battery Technology", desc: "Cutting-edge battery technology with extended range and rapid charging capabilities." },
                    { title: "Connected Vehicle", desc: "Seamless connectivity with smart home integration, over-the-air updates, and remote vehicle control." },
                    { title: "Autonomous Driving", desc: "Advanced driver assistance systems paving the way to fully autonomous driving capabilities." }
                ]
            },
            research: {
                title: "Research & Development",
                desc: "Our state-of-the-art R&D facilities house some of the brightest minds in automotive engineering, working tirelessly to push the boundaries of what's possible.",
                list: [
                    "Over 2,000 engineers and researchers",
                    "Multiple testing facilities worldwide",
                    "Partnerships with leading tech companies",
                    "Investment of $2B+ annually in R&D"
                ]
            }
        },
        newsroom: {
            readMore: "Read More"
        },
        service: {
            title: "Service",
            intro: "Need a helping hand? Choose a service.",
            cards: {
                booking: {
                    title: "Booking",
                    desc: "Is your car due for a service? Skip the queues at our service centers and schedule your appointment today!",
                    btn: "Book Appointment"
                },
                feedback: {
                    title: "Feedback",
                    desc: "Contact the service desk for help with your request, questions and issues. Get help via phone or email.",
                    btn: "Send Feedback"
                },
                recall: {
                    tag: "Safety Update",
                    title: "BAIC X7 Recall Notice",
                    subtitle: "(2022-2023 Models)",
                    desc: "Certain BAIC X7 models are being recalled due to a potential issue with the electrical fuse box.",
                    btn: "View More"
                }
            }
        },
        contact: {
            title: "Contact Us",
            cards: {
                phone: "Phone",
                whatsapp: "WhatsApp",
                locationText: "Find us on Google Maps"
            },
            form: {
                title: "Get in Touch",
                subtitle: "We'd love to hear from you. Please fill out this form.",
                toast: {
                    sent: "Message Sent",
                    desc: "We have received your message and will contact you shortly."
                },
                fields: {
                    title: "Title",
                    mr: "Mr.",
                    ms: "Ms.",
                    mrs: "Mrs.",
                    firstName: "First Name",
                    lastName: "Last Name",
                    phone: "Phone Number",
                    nationality: "Country",
                    uae: "UAE",
                    saudi: "Saudi Arabia",
                    other: "Other",
                    email: "Email Address",
                    mediaName: "Message",
                    iAmNotRobot: "I am not a robot",
                    submit: "Submit",
                    privacy: "I agree to the privacy statement and understand how my personal data will be processed."
                },
                placeholders: {
                    select: "Select...",
                    firstName: "Enter your first name",
                    lastName: "Enter your last name",
                    phone: "Enter your phone number",
                    email: "Enter your email",
                    description: "How can we help you?"
                },
                submit: "Submit"
            }
        },
        gallery: {
            tabs: {
                all: "All",
                videos: "Videos",
                images: "Images"
            },
            categories: {
                corporate: "Corporate",
                models: "Models",
                offRoad: "Off-Road",
                interior: "Interior",
                events: "Events"
            },
            filterModels: {
                all: "All Models",
                bj30Hybrid: "BJ30 Hybrid",
                bj40Honor: "BJ40 One / Honor",
                bj40Pro: "BJ40 Pro",
                u5Plus: "U5 Plus"
            }
        },
        bookService: {
            sidebar: {
                title: "Service Booking",
                heading: "Schedule Your Service",
                desc: "Experience premium care for your vehicle. Book your appointment in a few simple steps.",
                steps: {
                    location: { title: "Select Location", desc: "Choose your nearest authorized service center." },
                    date: { title: "Choose Date", desc: "Pick a convenient time for your visit." },
                    vehicle: { title: "Vehicle Details", desc: "Tell us about your BAIC model." }
                }
            },
            form: {
                location: {
                    title: "Location Settings",
                    emirate: "Emirate",
                    serviceCenter: "Service Center"
                },
                date: {
                    title: "Date & Preferences",
                    time: "Preferred Time",
                    note: "Service advisors will confirm the specific time availability upon booking."
                },
                details: {
                    title: "Personal & Vehicle Info",
                    vehicleInfo: "Vehicle Information",
                    model: "Model",
                    year: "Year",
                    mileage: "Current Mileage",
                    licensePlate: "License Plate",
                    contactInfo: "Contact Information",
                    title: "Title",
                    firstName: "First Name",
                    lastName: "Last Name",
                    email: "Email Address",
                    phone: "Phone Number"
                },
                submit: "Confirm Booking",
                agreement: "By booking, you agree to our"
            },
            placeholders: {
                selectModel: "Select Model",
                selectYear: "Select Year",
                mileage: "e.g. 15,000 km",
                license: "e.g. A 12345"
            }
        }
    },
    ar: {
        ggs: {
            title: "رمال الخليج الكبرى",
            subtitle: "رمال الخليج الكبرى - الموزع الرسمي لمركبات بايك في سلطنة عمان",
            p1: "تأسست شركة رمال الخليج الكبرى في عام 2016 في سلطنة عمان، ثم توسعت أعمالها لاحقاً إلى المملكة العربية السعودية، لتسجل مسيرة متميزة في دعم نمو وتطوير القطاعات الصناعية في المنطقة. ويتمتع مؤسسوا الشركة بشغف التميز والرؤية المستقبلية الواضحة، واضعين الأساس لشركة تواصل الابتكار والنمو بثبات.",
            p2: "تقدم شركة رمال الخليج الكبرى مجموعة متكاملة من حلول المعدات الثقيلة، ومعدات مناولة المواد، ومعدات الإنشاءات، ومركبات الركاب، والمركبات التجارية، وأنظمة توليد الطاقة، ومعدات الرفع الصناعية، والمعدات المتخصصة لمختلف القطاعات. كما تتعاون الشركة مع أبرز المصنّعين العالميين لضمان تقديم أعلى قيمة لعملائنا، عبر أحدث التقنيات وأرقى معايير الجودة في المنتجات والخدمات.",
            vision: {
                title: "الرؤية",
                desc: "\"مجموعة تجارية معترف بها عالمياً تبني علاقات دائمة مع العملاء.\""
            },
            mission: {
                title: "المهمة",
                desc: "\"التنويع وتقديم منتجات وخدمات عالمية المستوى بشكل مبتكر، من خلال موظفين متمكنين وخلق قيمة لأصحاب المصلحة.\""
            },
            values: [
                {
                    title: "النزاهة",
                    desc: "نلتزم بأعلى معايير الصدق والمبادئ الأخلاقية في كل إجراء."
                },
                {
                    title: "المسؤولية",
                    desc: "نتحمل المسؤولية الشخصية عن أفعالنا ونولي اهتماماً دقيقاً لاحتياجات عملائنا."
                },
                {
                    title: "الشغف",
                    desc: "يدفعنا دافع قوي للإنجاز والنمو وتقديم التميز."
                },
                {
                    title: "التميز",
                    desc: "نسعى بلا كلل لتجاوز التوقعات ووضع معايير جديدة في الجودة."
                }
            ]
        },
        afterSales: {
            integrity: {
                title: "النزاهة",
                desc: "قطع غيار أصلية وأسعار شفافة ومعقولة"
            },
            warm: {
                title: "الدفء",
                desc: "مراكز خدمة مريحة وإصلاح وصيانة سريعة"
            },
            care: {
                title: "العناية",
                desc: "التركيز على احتياجات العملاء وخدمة ما بعد البيع المخصصة"
            },
            professional: {
                title: "الاحترافية",
                desc: "مرافق متقدمة وفريق خدمة محترف"
            }
        },
        careers: {
            hero: {
                title: "الوظائف",
                subtitle: "شكل مستقبل تكنولوجيا السيارات معنا."
            },
            generalApp: {
                title: "طلب عام",
                desc: "لا ترى وظيفة محددة تناسبك؟ أرسل طلبك العام هنا، وسنتصل بك عند توفر منصب مناسب."
            },
            form: {
                title: "اللقب",
                firstName: "الاسم الأول",
                lastName: "اسم العائلة",
                email: "البريد الإلكتروني",
                phone: "رقم الهاتف",
                nationality: "الجنسية",
                position: "المنصب المهتم به",
                cv: "تحميل السيرة الذاتية (PDF/DOC، بحد أقصى 5 ميجابايت)",
                chooseFile: "اختر ملفاً",
                noFile: "لم يتم اختيار ملف",
                message: "رسالة / خطاب تغطية",
                submit: "إرسال الطلب",
                submitting: "جاري الإرسال...",
                placeholders: {
                    select: "اختر",
                    firstName: "الاسم الأول",
                    lastName: "اسم العائلة",
                    email: "email@example.com",
                    phone: "50 123 4567",
                    nationality: "اختر الجنسية",
                    position: "مثلاً مسؤول مبيعات",
                    message: "أخبرنا لماذا ستكون مناسباً..."
                },
                options: {
                    mr: "السيد",
                    ms: "الآنسة",
                    mrs: "السيدة",
                    uae: "الإمارات",
                    other: "أخرى"
                }
            },
            whyJoin: {
                title: "لماذا تنضم إلى بايك؟",
                growth: {
                    title: "فرص النمو",
                    desc: "نحن نستثمر في موظفينا. من برامج التدريب إلى الإرشاد، نساعدك في بناء مهنة، وليس مجرد وظيفة."
                },
                innovation: {
                    title: "الابتكار",
                    desc: "اعمل مع تقنيات السيارات المتطورة وكن جزءاً من علامة تجارية تحدد مستقبل التنقل."
                },
                culture: {
                    title: "ثقافة شاملة",
                    desc: "انضم إلى فريق متنوع حيث كل صوت مهم. نحن نؤمن بالتعاون والاحترام والنجاح المشترك."
                }
            }
        },
        home: {
            banners: [
                {
                    title: "BJ40 برو",
                    subtitle: "قوة لا تعرف التنازل، وتحكم يصنع الفرق، وثقة تُرافقك إلى أقصى الحدود",
                    buttonText: "اكتشف المزيد"
                },
                {
                    title: "BJ40 هونور",
                    subtitle: "المغامرة على الطرق الوعرة  كما يجب أن تكون",
                    buttonText: "اكتشف المزيد"
                },
                {
                    title: "BJ30 هايبرد",
                    subtitle: "كفاءة هجينة. رحابة عائلية. أداء بلا تنازل.",
                    buttonText: "اكتشف المزيد"
                },
                {
                    title: "U5 بلس",
                    subtitle: "السيدان العائلية… نبض الحياة بأسلوب عصري.",
                    buttonText: "اكتشف المزيد"
                },
                {
                    title: "مغامرة للجميع",
                    subtitle: "مُصممة لكل التضاريس",
                    buttonText: "اكتشف المزيد"
                }
            ]
        },
        modelShowcase: {
            categories: {
                offRoad: "الطرق الوعرة",
                sedan: "السيدان"
            },
            models: {
                bj30: "BJ30 هايبرد",
                bj40Honor: "BJ40 هونور",
                bj40Pro: "BJ40 برو",
                u5Plus: "U5 بلس"
            },
            view360: "رؤية محيطية شاملة 360 درجة"
        },
        featureCards: {
            offRoadVehicle: "مركبة الطرق الوعرة",
            baicHistory: "تاريخ بايك",
            learnMore: "اعرف المزيد"
        },
        serviceCentres: {
            showroomsTitle: "صالات العرض",
            serviceCentersTitle: "مراكز الخدمة",
            salesDesc: "تمتلك مبيعات بايك شبكة تغطي جميع أنحاء عمان. في معظم المواقع، تتوفر مرافق حصرية تلبي متطلبات المبيعات للعملاء. في المواقع الرئيسية، تم تحديث منافذنا الآن بمعايير عالمية لتقديم المبيعات وقطع الغيار والخدمة للعملاء.",
            serviceDesc: "تمتلك خدمة بايك شبكة تغطي جميع أنحاء عمان. في معظم المواقع، تتوفر مرافق حصرية تلبي متطلبات الخدمة للعملاء. في المواقع الرئيسية، تم تحديث منافذنا الآن بمعايير عالمية لتقديم المبيعات وقطع الغيار والخدمة للعملاء.",
            contactDetails: "تفاصيل الاتصال",
            workingTiming: "أوقات العمل",
            nearestLandmark: "أقرب معلم",
            map: "خريطة",
            satellite: "قمر صناعي",
            tollFree: "الرقم المجاني",
            showroom: "صالات العرض",
            mobile: "الجوال",
            centers: [
                {
                    id: 1,
                    type: 'showroom',
                    name: 'معرض القرم',
                    address: 'القرم، مسقط',
                    landmark: 'مبنى بهوان، مقابل سيتي سنتر القرم',
                    contacts: ['الرقم المجاني: 80050800', 'الجوال: 79999073'],
                    timing: ['السبت - الخميس: 8:30 ص - 1:30 م، 4:00 م - 7:00 م', 'الجمعة: مغلق'],
                    mapUrl: 'https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2794.2595257188273!2d58.492442!3d23.609262!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDM2JzMzLjMiTiA1OMKwMjknMzIuOCJF!5e1!3m2!1sen!2sin!4v1768894154353!5m2!1sen!2sin'
                },
                {
                    id: 2,
                    type: 'showroom',
                    name: 'معرض صحار',
                    address: 'صحار',
                    landmark: 'شارع البهجة',
                    contacts: ['الرقم المجاني: 80050800', 'الجوال: 95351200'],
                    timing: ['السبت - الخميس: 8:30 ص - 1:30 م، 4:00 م - 7:00 م', 'الجمعة: مغلق'],
                    mapUrl: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1422766.226049702!2d55.5305507!3d24.322487!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e8b5d42a5b887a5%3A0x9c40acd375ab9c6f!2sChangan%20Oman%2C%20Sohar!5e1!3m2!1sen!2sin!4v1768894245446!5m2!1sen!2sin'
                },
                {
                    id: 3,
                    type: 'showroom',
                    name: 'معرض بركاء',
                    address: 'بركاء',
                    landmark: 'بالقرب من لولو هايبر ماركت، بجوار مكتب المدينة للتأمين، بركاء.',
                    contacts: ['الرقم المجاني: 80050800', 'معرض الالصور: 96629010'],
                    timing: ['السبت - الخميس: 8:30 ص - 1:30 م، 4:00 م - 7:00 م', 'الجمعة: مغلق'],
                    mapUrl: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d357502.29312140896!2d57.5742911!3d23.6689047!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e8dc4d30fe70591%3A0x6eb3cc9e189f4da4!2sCHANGAN%20AUTO%20SHOWROOM!5e1!3m2!1sen!2sin!4v1768894287914!5m2!1sen!2sin'
                },
                {
                    id: 4,
                    type: 'showroom',
                    name: 'معرض نزوى',
                    address: 'نزوى',
                    landmark: 'بالقرب من فندق الديار ومحطة شل عُمان',
                    contacts: ['الرقم المجاني: 80050800', 'معرض الالصور: 96628930'],
                    timing: ['السبت - الخميس: 8:30 ص - 1:30 م، 4:00 م - 7:00 م', 'الجمعة: مغلق'],
                    mapUrl: 'https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2809.0527555128688!2d57.533035!3d22.905357!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjLCsDU0JzE5LjMiTiA1N8KwMzEnNTguOSJF!5e1!3m2!1sen!2sin!4v1768894343963!5m2!1sen!2sin'
                },
                {
                    id: 5,
                    type: 'showroom',
                    name: 'معرض عبري',
                    address: 'عبري',
                    landmark: 'بالقرب من البنك الوطني العماني، عبري',
                    contacts: ['الرقم المجاني: 80050800', 'معرض الالصور: 96628930'],
                    timing: ['السبت - الخميس: 8:30 ص - 1:30 م، 4:00 م - 7:00 م', 'الجمعة: مغلق'],
                    mapUrl: 'https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2802.55087923698!2d56.480489999999996!3d23.217218000000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDEzJzAyLjAiTiA1NsKwMjgnNDkuOCJF!5e1!3m2!1sen!2sin!4v1768894382887!5m2!1sen!2sin'
                },
                {
                    id: 6,
                    type: 'showroom',
                    name: 'معرض الصور',
                    address: 'الصور',
                    landmark: 'بالقرب من مستشفى بدر السماء، صور',
                    contacts: ['الرقم المجاني: 80050800', 'معرض الالصور: 96628920'],
                    timing: ['السبت - الخميس: 8:30 ص - 1:30 م، 4:00 م - 7:00 م', 'الجمعة: مغلق'],
                    mapUrl: 'https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2815.9720508015757!2d59.49772300000001!3d22.569!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjLCsDM0JzA4LjQiTiA1OcKwMjknNTEuOCJF!5e1!3m2!1sen!2sin!4v1768894470282!5m2!1sen!2sin'
                },
                {
                    id: 7,
                    type: 'showroom',
                    name: 'معرض صلالة',
                    address: 'صلالة',
                    landmark: 'المنطقة الصناعية، بالقرب من بنك مسقط',
                    contacts: ['الرقم المجاني: 80050800', 'معرض الالصور: 96629050'],
                    timing: ['السبت - الخميس: 8:30 ص - 1:30 م، 4:00 م - 7:00 م', 'الجمعة: مغلق'],
                    mapUrl: 'https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2915.977539192713!2d54.04372799999999!3d17.018175!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTfCsDAxJzA1LjQiTiA1NMKwMDInMzcuNCJF!5e1!3m2!1sen!2sin!4v1768894509980!5m2!1sen!2sin'
                },
                {
                    id: 101,
                    type: 'service',
                    name: 'مركز خدمة العذيبة',
                    address: 'العذيبة',
                    landmark: 'بالقرب من الميرة هايبر ماركت، العذيبة',
                    contacts: ['الرقم المجاني: 80050800', 'الجوال: 94589715 / 97440789'],
                    timing: ['الأحد - الخميس: 7:30 ص - 7:00 م', 'السبت: 8:30 ص - 1:00 م، 2:00 م - 5:30 م', 'الجمعة: مغلق'],
                    mapUrl: ""
                },
                {
                    id: 102,
                    type: 'service',
                    name: 'مركز خدمة الوادي الكبير',
                    address: 'الوادي الكبير',
                    landmark: 'بالقرب من نستو هايبر ماركت، الوادي الكبير',
                    contacts: ['الرقم المجاني: 80050800', 'الجوال: 96580057'],
                    timing: ['الأحد - الخميس: 7:30 ص - 7:00 م', 'السبت: 8:30 ص - 1:00 م، 2:00 م - 5:30 م', 'الجمعة: مغلق'],
                    mapUrl: ""
                },
                {
                    id: 103,
                    type: 'service',
                    name: 'مركز خدمة العامرات',
                    address: 'العامرات',
                    landmark: 'لولو هايبر ماركت، العامرات',
                    contacts: ['الرقم المجاني: 80050800'],
                    timing: ['الأحد - الخميس: 8:30 ص - 7:00 م', 'السبت: 8:30 ص - 1:00 م، 2:00 م - 5:30 م', 'الجمعة: مغلق'],
                    mapUrl: ''
                },
                {
                    id: 104,
                    type: 'service',
                    name: 'مركز خدمة المعبيلة',
                    address: 'المعبيلة',
                    landmark: 'شارع الإعمار، شارع رقم ٧٧١٣',
                    contacts: ['الرقم المجاني: 80050800', 'الجوال: 9533 0380'],
                    timing: ['الأحد - الخميس: 7:30 ص - 7:00 م', 'السبت: 8:30 ص - 1:00 م، 2:00 م - 5:30 م', 'الجمعة: مغلق'],
                    mapUrl: ''
                },
                {
                    id: 105,
                    type: 'service',
                    name: 'الرسيل - ورشة السمكرة',
                    address: 'الرسيل',
                    landmark: 'بالقرب من أورينتال للخرسانة الجاهزة',
                    contacts: ['الرقم المجاني: 80050800', 'الجوال: 97163035'],
                    timing: ['الأحد - الخميس: 8:30 ص - 1:00 م، 2:00 م - 5:30 م', 'الجمعة والسبت: مغلق'],
                    mapUrl: ''
                },
                {
                    id: 106,
                    type: 'service',
                    name: 'مركز خدمة بركاء',
                    address: 'بركاء',
                    landmark: 'بالقرب من لولو هايبر ماركت، بجوار مكتب المدينة للتأمين، بركاء.',
                    contacts: ['الرقم المجاني: 80050800', 'الجوال: 9509 4517'],
                    timing: ['الأحد - الخميس: 8:30 ص - 1:00 م، 2:00 م - 5:30 م', 'الجمعة والسبت: مغلق'],
                    mapUrl: ''
                },
                {
                    id: 107,
                    type: 'service',
                    name: 'مركز خدمة صحار',
                    address: 'صحار',
                    landmark: 'شارع البهجة',
                    contacts: ['الرقم المجاني: 80050800', 'الجوال: 9400 0961'],
                    timing: ['الأحد - الخميس: 7:30 ص - 7:00 م', 'السبت: 8:30 ص - 1:00 م، 2:00 م - 5:30 م', 'الجمعة: مغلق'],
                    mapUrl: ''
                },
                {
                    id: 108,
                    type: 'service',
                    name: 'مركز خدمة نزوى',
                    address: 'نزوى',
                    landmark: 'بالقرب من فندق الديار ومحطة شل عُمان',
                    contacts: ['الرقم المجاني: 80050800', 'الجوال: 9709 7968'],
                    timing: ['الأحد - الخميس: 8:30 ص - 1:00 م، 2:00 م - 5:30 م', 'الجمعة والسبت: مغلق'],
                    mapUrl: ''
                },
                {
                    id: 109,
                    type: 'service',
                    name: 'مركز خدمة عبري',
                    address: 'عبري',
                    landmark: 'بالقرب من البنك الوطني العماني، عبري',
                    contacts: ['الرقم المجاني: 80050800', 'الجوال: 9418 9060'],
                    timing: ['الأحد - الخميس: 8:30 ص - 1:00 م، 2:00 م - 5:30 م', 'الجمعة والسبت: مغلق'],
                    mapUrl: ''
                },
                {
                    id: 110,
                    type: 'service',
                    name: 'مركز خدمة الصور',
                    address: 'الصور',
                    landmark: 'بالقرب من مستشفى بدر السماء، صور',
                    contacts: ['الرقم المجاني: 80050800', 'الجوال: 9410 1939'],
                    timing: ['الأحد - الخميس: 8:30 ص - 1:00 م، 2:00 م - 5:30 م', 'الجمعة والسبت: مغلق'],
                    mapUrl: ''
                },
                {
                    id: 111,
                    type: 'service',
                    name: 'مركز خدمة الدقم',
                    address: 'الدقم',
                    landmark: 'الدقم',
                    contacts: ['الرقم المجاني: 80050800'],
                    timing: ['الأحد - الخميس: 8:30 ص - 1:00 م، 2:00 م - 5:30 م', 'الجمعة والسبت: مغلق'],
                    mapUrl: ''
                },
                {
                    id: 113,
                    type: 'service',
                    name: 'مركز خدمة الموالح',
                    address: 'الموالح',
                    landmark: 'بالقرب من سوق الخضار القديم، طريق نزوى.',
                    contacts: ['الرقم المجاني: 80050800', 'الجوال: 79913319 / 7913 7980'],
                    timing: ['الأحد - الخميس: 7:30 ص - 7:00 م', 'السبت: 8:30 ص - 1:00 م، 2:00 م - 5:30 م', 'الجمعة: مغلق'],
                    mapUrl: ''
                },
                {
                    id: 112,
                    type: 'service',
                    name: 'مركز خدمة صلالة',
                    address: 'صلالة',
                    landmark: 'المنطقة الصناعية، بالقرب من بنك مسقط',
                    contacts: ['الرقم المجاني: 80050800', 'الجوال: 9533 4250'],
                    timing: ['الأحد - الخميس: 8:30 ص - 1:00 م، 2:00 م - 5:30 م', 'الجمعة والسبت: مغلق'],
                    mapUrl: ''
                }
            ],
        },
        models: {
            title: "طرازاتنا",
            subtitle: "استكشف تشكيلة بايك الكاملة",
            all: "الجميع",
            offRoad: "الدفع الرباعي",
            suv: "سيارات SUV",
            sedan: "السيدان",
            viewDetails: "عرض التفاصيل",
            testDrive: "اختبار القيادة",
            startingAt: "يبدأ من",
            list: [
                {
                    name: 'BJ80',
                    category: 'Off-road',
                    image: 'https://images.pexels.com/photos/35290260/pexels-photo-35290260.jpeg',
                    price: 'يبدأ من 65,000$',
                    specs: { power: '320 حصان', fuel: 'هجين', seats: '7 مقاعد', drive: '4WD' },
                },
                {
                    name: 'BJ60',
                    category: 'Off-road',
                    image: 'https://images.pexels.com/photos/104401/pexels-photo-104401.jpeg',
                    price: 'يبدأ من 52,000$',
                    specs: { power: '280 حصان', fuel: 'بنزين', seats: '5 مقاعد', drive: '4WD' },
                },
                {
                    name: 'BJ40 C',
                    category: 'Off-road',
                    image: 'https://images.pexels.com/photos/215528/pexels-photo-215528.jpeg',
                    price: 'يبدأ من 45,000$',
                    specs: { power: '250 حصان', fuel: 'ديزل', seats: '5 مقاعد', drive: '4WD' },
                },
                {
                    name: 'X55',
                    category: 'SUV',
                    image: 'https://images.pexels.com/photos/35290260/pexels-photo-35290260.jpeg',
                    price: 'يبدأ من 35,000$',
                    specs: { power: '190 حصان', fuel: 'بنزين', seats: '5 مقاعد', drive: 'FWD' },
                },
                {
                    name: 'X7',
                    category: 'SUV',
                    image: 'https://images.pexels.com/photos/104401/pexels-photo-104401.jpeg',
                    price: 'يبدأ من 42,000$',
                    specs: { power: '220 حصان', fuel: 'هجين', seats: '7 مقاعد', drive: 'AWD' },
                },
                {
                    name: 'D50',
                    category: 'Sedan',
                    image: 'https://images.pexels.com/photos/70912/pexels-photo-70912.jpeg',
                    price: 'يبدأ من 28,000$',
                    specs: { power: '160 حصان', fuel: 'بنزين', seats: '5 مقاعد', drive: 'FWD' },
                },
            ],
            bj30: {
                hero: {
                    title: "ابدأ مغامرتك",
                    subtitle: "يجمع الطراز الجديد كلياً BJ30 بين القدرات العالية على الطرق الوعرة وسلاسة القيادة في البيئة الحضرية. وبفضل منظومة ماجيك كور الهجينة ونظام التضاريس الذكي، هو جاهز لأي رحلة."
                },
                intro: {
                    title: "ابدأ مغامرتك",
                    desc: "يجمع الطراز الجديد كلياً BJ30 بين القدرات العالية على الطرق الوعرة وسلاسة القيادة في البيئة الحضرية. وبفضل منظومة ماجيك كور الهجينة ونظام التضاريس الذكي، هو جاهز لأي رحلة.",
                    stats: {
                        turbo: { value: "1.5 لتر", label: "محرك هجين توربو" },
                        hp: { value: "403", label: "حصان (إجمالي)" },
                        torque: { value: "685", label: "نيوتن متر" },
                        accel: { value: "6.6 ثانية", label: "تسارع من 0 إلى 100 كم/س" }
                    }
                },
                atsPointsDesktop: [
                    { id: "roof", x: 52.0, y: 32.0, label: "سقف بقدرة عالية على تحمّل الأحمال" },
                    { id: "hardTop", x: 70.0, y: 34.0, label: "سقف صلب بتصميم مُعلّق على شكل L" },
                    { id: "mark", x: 69.0, y: 42.0, label: "موضع مخصص يتيح تخصيص الهوية التصميمية للمركبة." },
                    { id: "lamp", x: 20.0, y: 48.0, label: "مصابيح أمامية دائرية بتصميم حاجب العين" },
                    { id: "scratch", x: 40.0, y: 62.0, label: "تصميم خارجي مقاوم للخدوش" },
                    { id: "approach", x: 22.0, y: 70.0, label: "زاوية الإقتراب 25 درجة" },
                    { id: "departure", x: 76.0, y: 70.0, label: "زاوية المغادرة 30 درجة" }
                ],
                atsPointsMobile: [
                    { id: "roof", x: 52.0, y: 32.0, label: "سقف بقدرة عالية على تحمّل الأحمال" },
                    { id: "hardTop", x: 73.0, y: 34.0, label: "سقف صلب بتصميم مُعلّق على شكل L" },
                    { id: "mark", x: 82.0, y: 38.0, label: "موضع مخصص يتيح تخصيص الهوية التصميمية للمركبة." },
                    { id: "lamp", x: 22.0, y: 48.0, label: "مصابيح أمامية دائرية بتصميم حاجب العين" },
                    { id: "scratch", x: 40.0, y: 72.0, label: "تصميم خارجي مقاوم للخدوش" },
                    { id: "approach", x: 15.0, y: 85.0, label: "زاوية الإقتراب 25 درجة" },
                    { id: "departure", x: 86.0, y: 85.0, label: "زاوية المغادرة 30 درجة" }
                ],
                exterior: {
                    face: { title: "هوية التصميم العائلي", desc: "شبك أمامي مميز بخمسة فتحات، تم إعادة تصميمه ليواكب عصر المركبات الكهربائية." },
                    led: { title: "إضاءة LED الذكية", desc: "مصابيح أمامية بتقنية مصفوفة LED مع مؤثرات ترحيبية ديناميكية" },
                    rear: { title: "حضور قوي", desc: "تصميم خلفي بأسلوب جريء وعصري يتمازج مع المصابيح الخلفية العمودية" }
                },
                interior: {
                    tag: "مقصورة ذكية",
                    title: "تجربة تقنية من كافة النواحي",
                    dashboard: "شاشة مركزية قياس 14.6 بوصة + شاشة عدادات قياس 10.25 بوصة",
                    features: {
                        gear: { title: "ناقل حركة إلكتروني", desc: "ناقل حركة إلكتروني مستوحى من تصميم الطائرات للتحكم الدقيق" },
                        light: { title: "إضاءة محيطية", desc: "إضاءة محيطية متعددة الألوان تتكيف مع أسلوب القيادة والمزاج" },
                        space: { title: "مساحة رحبة", desc: "مقاعد تتميز بالاتساع توفر أقصى درجات العملية والراحة" }
                    }
                },
                performance: {
                    tag: "تقنية الهجين المتطورة",
                    title: "قوة منظومة ماجيك كور الهجينة المتطورة",
                    desc: "يوفر المحرك الهجين المتخصص أداء قوياً وكفاءة استثنائية، أثناء الانتقال السلس بين وضعي القيادة الكهربائية والقيادة بمحرك البنزين لتحقيق أفضل مدى وأعلى أداء",
                    features: ["كفاءة حرارية عالية", "إدارة ذكية للطاقة", "تسارع سلس"]
                },
                ats: {
                    title: "نظام التحكم في التضاريس ATS",
                    desc: "يعمل نظام التحكم في التضاريس ATS على ضبط أنظمة التحكم المختلفة في المركبة تلقائياً، بما يتيح لها التكيف مع مختلف أنواع التضاريس بكفاءة عالية."
                },
                safety: {
                    tag: "هيكل آمن عالي المتانة",
                    desc: "تم تطوير هيكل المركبة وفق منهجية هندسية متقدمة لتحسين توزيع الأحمال وتعزيز الصلابة الالتوائية، بما يضمن الحفاظ على سلامة البنية الهيكلية وتقليل التشوهات عند الاصطدام. ويعتمد التصميم الأساسي على وحدات امتصاص للطاقة ثلاثية المراحل، توفر حماية فعالة لمقصورة الركاب وتضمن مستوى عالياً من السلامة الهيكلية حتى في ظروف التصادم الشديدة.",
                    stats: {
                        steel: { value: "63.40%", label: "فولاذ عالي الصلابة" },
                        stiffness: { value: "25420 نيوتن متر", label: "أقصى صلابة التواء" },
                        positions: { value: "20 موضعاً", label: "فولاذ مشكل حرارياً" }
                    }
                },
                specs: {
                    tag: "البيانات التقنية",
                    title: "المواصفات",
                    items: {
                        engine: { label: "المحرك", value: "تيربو 1.5 لتر", sub: "محرك هجين" },
                        transmission: { label: "ناقل الحركة", value: "2 DHT", sub: "ناقل حركة هجين مخصص" },
                        power: { label: "صافي القوة", value: "403 حصان" },
                        torque: { label: "أقصى عزم", value: "685 نيوتن متر" },
                        drive: { label: "نظام الدفع", value: "دفع بكامل العجلات", sub: "مستمر" },
                        ground: { label: "الارتفاع الأدنى عن الأرض", value: "215 ملم" },
                        approach: { label: "زاوية الاقتراب", value: "24.5", sub: "درجة" },
                        departure: { label: "زاوية المغادرة", value: "30", sub: "درجة" }
                    }
                },
                footer: {
                    title: "هل أنت مستعد لتجربة BJ30؟",
                    desc: "متعة مطلقة ورحابة مثالية للرحلات العائلية الطويلة، على الطرق الوعرة والطرق المعبدة، بفضل تقنية الهجين المتقدمة.",
                    btn: "احجز تجربة قيادة"
                }
            },
            bj40Plus: {
                hero: {
                    title: "BJ40 هونور",
                    subtitle: "عودة الأسطورة"
                },
                sections: {
                    smartCabin: { tag: "مقصورة ذكية", title: "ابتكار تقني متقدم" },
                    interior: { title: "مقصورة داخلية راقية", desc: "على النقيض من المظهر الخارجي القوي، تقدم المقصورة الداخلية مواد ناعمة الملمس، وإضاءة محيطية، ومقاعد مصممة بمعايير هندسية عالية لتوفير أقصى درجات الراحة في الرحلات الطويلة." },
                    steering: { title: "تحكم متعدد الوظائف", desc: "عجلة قيادة مكسوة بالجلد مع مفاتيح تحكم مدمجة للصوت، ونظام تثبيت السرعة، والمكالمات الهاتفية، لتضع كل شيء في متناول يدك." },
                    gear: { title: "تبديل سرعات دقيق", desc: "ناقل حركة أوتوماتيكي من 8 سرعات يضمن انسيابية توزيع القوة وكفاءة الأداء، سواء في القيادة داخل المدينة أو في مغامرات الطرق الوعرة." },
                    safety: { tag: "السلامة", title: "حماية شاملة" },
                    performance: { tag: "لأداء ", title: "المواصفات الفنية" },
                    footer: { title: "شغل المحرك", desc: "جرب BJ40 Plus بنفسك. احجز تجربة القيادة اليوم.", btn: "إحجز تجربة قيادة" }
                },
                specs: [
                    { label: 'المحرك', value: '2.0 لتر', sub: 'محرك توربو' },
                    { label: 'ناقل الحركة', value: '8AT', sub: 'أوتوماتيكي 8 سرعات' },
                    { label: 'صافي القوة', value: '215 حصان', sub: '' },
                    { label: 'أقصى عزم', value: '380 نيوتن متر', sub: '' },
                    { label: 'نظام الدفع', value: 'دفع رباعي (4WD)', sub: '' },
                    { label: 'الإرتفاع الأدنى عن الأرض', value: '210 ملم', sub: '' },
                    { label: 'زاوية الإقتراب', value: '37 درجة', sub: '' },
                    { label: 'زاوية المغادرة', value: '31 درجة', sub: '' }
                ],
                features: [
                    {
                        title: "تصميم جريء بلمسة عصرية",
                        desc: "حيث تلتقي الشخصية القوية بالأناقة الراقية."
                    },
                    {
                        title: "إضاءة LED حلقيّة — هوية ضوئية جريئة تعكس الشخصية المتفرّدة",
                        desc: "يضم التصميم الخارجي ما يقارب 200 مصدر إضاءة LED موزّعة بعناية هندسية،لتشكّل شريط ضوئي مبتكر بتصميم منفصل"
                    },
                    {
                        title: "تفاصيل مخفية تكشف الجمال الميكانيكي",
                        desc: "مفصلات مكشوفة بتصميم هندسي متين، وهيكل بآلية فتح ثلاثية الأجزاء، إلى جانب نافذة صندوق أمتعة مستقلة الفتح، جميعها تتكامل لتوفير مرونة تشغيلية عالية، وسهولة وصول عملية، مع إبراز الطابع الميكانيكي الجريء والتصميم القابل للتكيّف مع مختلف الاستخدامات."
                    },
                    {
                        title: "تقنيات داخلية ذكية ترتقي بتجربة قيادتك",
                        desc: "مُجهّزة بشاشة عدادات رقمية LCD قياس 12.3 بوصة، إلى جانب شاشة عرض مركزية قياس 10 بوصات"
                    },
                    {
                        title: "إضاءة محيطية متعددة الألوان تتناغم مع حالتك المزاجية",
                        desc: "اختر من بين 256 لونًا للإضاءة المحيطية، بخمسة ألوان مُوصى بها — الأحمر، الأخضر، الأزرق الجليدي، الأبيض، والبرتقالي. استمتع بثلاثة أنماط إضاءة مختلفة: إضاءة ثابتة بلون واحد، إضاءة بلون واحد، وإضاءة متعددة الألوان، تضفي طابعًا بصريًا راقيًا على المقصورة."
                    },
                    {
                        title: "مقبض ناقل حركة إلكتروني بتصميم عصري لتعزيز تجربة القيادة",
                        desc: "مصمم مع شاشة مدمجة تعرض وضع الجير مباشرة، بإضاءة خلفية تعمل عند التشغيل حيث يقوم النظام بتحويل ناقل الحركة تلقائياً إلى وضع الوقوف (P) عند مغادرة السائق للسيارة أو عند إطفاء المحرك.من خلال العودة التلقائية لوضع (P)، يتم قفل ناقل الحركة تلقائياً، مما يعزّز مستويات السلامة ويمنع حدوث أي حركة غير آمنة."
                    },
                    {
                        title: "نظام الأمان الذي يمنحك الثقة أينما كنت",
                        desc: "يوفّر نظام الثبات الإلكتروني المتقدّم ESP  مدعومًا بثماني تقنيات سلامة أساسية منظومة حماية متكاملة تعزّز الثبات والتحكّم، لتمنح السائق أعلى مستويات الأمان والثقة سواء أثناء  القيادة داخل المدن أو المغامرات على الطرق الوعرة."
                    },
                    {
                        title: "هيكل صلب غير حامل للأحمال بحماية ثلاثية الأبعاد",
                        desc: "هيكل بتصميم قفصي عالي الصلابة مع مفاصل مُعزَّزة وعمود B مُشكَّل بتصميم متكامل، ما يعزّز صلابة البنية الهيكلية ومقاومتها للتشوه. اجتاز اختبار تحمّل ضغط السقف الثابت بنسبة تتجاوز المعاييربأكثر من 62.2% صُمّم لتحقيق امتصاص فعّال لطاقة الصدمات مع الحفاظ على خفّة الوزن، حيث يستطيع امتصاص ما يصل إلى 23% من طاقة التصادم، بما يعزّز مستويات السلامة الهيكلية وحماية الركّاب."
                    },
                    {
                        title: "قدرات عبور فائقة ",
                        desc: [
                            "زاوية  الإقتراب  37°",
                            "زاوية المغلدرة  31°",
                            "أقصى زاوية يمكن للسيارة صعودها وتتجاوز العقبات دون أن يلامس منتصف هيكلها السفلي الأرض 23°",
                            "أقصى عمق مياه للخوض أو السير فيه بأمان يتجاوز 600 ملم (60 سنتيمتر)",
                            "أقصى عرض للخندق أو الفجوة العرضية  للعبور دون أن تعلق العجلات أو يتضرر الهيكله السفلي 500 ملم ",
                            "قدرة السيارة على تجاوز حواجز أو صخور أو عوائق بارتفاع يصل إلى 350 ملمs"
                        ]
                    }
                ]
            },
            bj40Pro: {
                hero: { title: "BJ40 PRO", subtitle: "تجرأ على الاستكشاف" },
                sections: {
                    design: { title: "التصميم المسيطر", classic: { title: "الإرث الكلاسيكي", desc: "يحافظ التصميم على الهوية الأصيلة لطراز BJ40 من خلال الشبك الأمامي الأيقوني بخمس فتحات مع تطعيمات كروم تعزّز الحضور القوي والطابع التراثي للمركبة. كما يوفّر الزجاج الأمامي العمودي والسقف القابل للفك تجربة قيادة مكشوفة بطابع مغامراتي أصيل، تمنح إحساسًا فريدًا بالحرية والانطلاق على مختلف التضاريس." }, stance: { title: "بنية هيكل جاهز لجميع التضاريس", desc: "تصميم خارجي قوي ومتين، صُمّم بعناية ليتحمل أقسى التضاريس وظروف القيادة الوعرة، مع حضور بصري يعكس الطابع الجريء لمركبات الطرق الوعرة" } },
                    splitTailDoor: { title: "باب خلفي مقسم", desc: "مع ميزات التخميد الجميلة والمريحة، يعزز التصميم المقطعي العلوي والسفلي من عملية الباب الخلفي." },
                    power: { title: "قوة لا تقهر", engine: { title: "محرك 2.0 لتر تيربو", desc: "يولد قوة صافية تبلغ 231 حصاناً وعزم دوران يصل إلى 386 نيوتن متر، ما يضمن أداءً قوياً واستجابة عالية لمختلف مسارات القيادة والتضاريس الصعبة." }, chassis: { title: "هيكل احترافي للطرق الوعرة", desc: "هيكل غير حامل للأحمال  مع نظام تعليق أمامي مستقل، يوفّر ثباتاً وتحكماً متقدماً وقدرات فائقة على المناورة أثناء القيادة على الطرق الوعرة" } },
                    partTime4WD: { title: "نظام الدفع الرباعي الجزئي", desc: "نظام دفع رباعي قابل للتفعيل عند الحاجة مع تحكم إلكتروني عبر مفتاح دوّار، ويضم أوضاع القيادة 2H و4H و4L و4A، لتوفير مرونة كاملة وتكيّف مثالي مع مختلف ظروف الطريق." },
                    cageBody: { title: "هيكل قفصي عالي الصلابة", desc: "تصميم قفصي بمواصفات عسكرية يحدّ بفاعلية من تشوهات الهيكل عند التصادم. تبلغ نسبة استخدام الفولاذ المُشكّل حرارياً 79.8%، مع معامل خفة وزن يبلغ 4.34، ما يعزز الصلابة الهيكلية وكفاءة الأداء." },
                    techTrim: { title: "تصميم داخلي بتقنيات متقدمة", desc: "مقصورة رحبة بزاوية رؤية واسعة ومساحات مريحة" },
                    skylight: { title: "سقف بانورامي واسع", desc: "سقف بانورامي كبير مع تحكم ذكي بالفتح والإغلاق، يوفّر إحساساً بالرحابة و الإستمتاع بالإضاءة الطبيعية داخل المقصورة." },
                    trunkSpace: { title: "مساحة تحميل وتخزين واسعة بالباب الخلفي", desc: "مقاعد خلفية قابلة للطي بضغطة زر لتتحول بسهولة إلى أرضية مسطحة، ما يوفر مساحة تحميل مرنة لاستيعاب الأمتعة الكبيرة، سواء للرحلات الطويلة أو الاستخدامات اليومية براحة تامة." },
                    interior: { tag: "مقصورة الدرجة الأولى", title: "التكنولوجيا والراحة" },
                    gallery: { title: "معرض نمط الحياة" },
                    specs: { tag: "البيانات الفنية", title: "المواصفات" },
                    footer: { title: "جاهز لتكون محترفاً؟", desc: "جرب قدرات الطرق الوعرة القصوى.", btn: "إحجز تجربة قيادة" }
                },
                specs: [
                    { label: 'المحرك', value: 'محرك 2.0 لتر تيربو', sub: 'بنزين' },
                    { label: 'ناقل الحركة', value: '8AT', sub: 'ZF 8 سرعات' },
                    { label: 'صافي القوة', value: '165 كيلوواط', sub: '231 حصان' },
                    { label: 'العزم الأقصى', value: '386 نيوتن متر', sub: '@ 1800-3600 دورة/دقيقة' },
                    { label: 'وضع القيادة', value: 'دفع رباعي', sub: 'جزئي (2H/4H/4L)' },
                    { label: 'الأبعاد', value: '4645 مم', sub: 'الطول' },
                    { label: 'الخلوص', value: '220 مم', sub: 'الحد الأدنى' },
                    { label: 'عمق الخوض', value: '750 مم', sub: 'الحد الأقصى' }
                ]
            },
            u5Plus: {
                hero: { title: "U5 PLUS", subtitle: "الجماليات الحديثة تلتقي بالتكنولوجيا الذكية." },
                sections: {
                    exterior: {
                        title: "المظهر الخارجي", subtitle: "حيث تلتقي الأناقة الكلاسيكية بالحديثة", desc: "تتميز بايك U5 PLUS بتصميم خارجي أنيق وعصري يتميز بخطوطه الديناميكية الهوائية ووقفته الجريئة. تتميز بشبك أمامي مذهل يمنحها مظهراً واثقاً وعصرياً، تكمله مصابيح أمامية LED حادة تعزز الرؤية والأناقة.", items: [
                            { title: "مصابيح أمامية LED", desc: "تم تصميم هذه المصابيح لتوفير إضاءة فائقة، وتحسين الرؤية، وجماليات حديثة، مما يجعلها ميزة بارزة في السيارة. تساعد هذه الإضاءة القوية على إضاءة الطريق أمامك بشكل أفضل." },
                            { title: "الشبك الأمامي", desc: "يتميز الشبك الأمامي لسيارة U5 بتصميم عصري وجذاب يكمل المظهر الخارجي الجريء والديناميكي للسيارة. بنمطه المميز، يضيف لمسة من الرقي والأناقة إلى الواجهة الأمامية." },
                            { title: "مصابيح خلفية LED", desc: "توفر مصابيح U5 الخلفية إضاءة ساطعة وواضحة، مما يضمن رؤية السيارة بوضوح للسائقين الآخرين، خاصة في ظروف الإضاءة المنخفضة والطقس السيئ. يعزز الانبعاث العالي السلامة من خلال جعل السيارة أكثر وضوحاً." },
                            { title: "جنوط ألمنيوم 16 بوصة", desc: "تتميز جنوط الألمنيوم مقاس 16 بوصة بتصميم عصري يكمل التصميم الخارجي لسيارة U5، مما يضيف لمسة من الرقي لمظهرها الأنيق ويعزز الجاذبية البصرية للسيارة." }
                        ]
                    },
                    safety: {
                        tag: "السلامة", title: "مبنية بقفص سلامة فائق القوة", desc: "مبنية بصلب مشكل حرارياً فائق القوة مصنف حتى 1500 ميجا باسكال، مع 50٪ من هيكل الجسم مصنوع من الصلب فائق القوة لتعزيز السلامة.", items: [
                            { title: "ABS + EBD + EBA", desc: "تم تجهيز U5 بتقنيات سلامة متقدمة لتعزيز حماية السائق والركاب. ومن بين هذه الميزات ABS و EBD و EBA، حيث يلعب كل منها دوراً حاسماً في الحفاظ على السيطرة والاستقرار أثناء ظروف القيادة المختلفة." },
                            { title: "الوسائد الهوائية", desc: "تم تجهيز بايك U5 PLUS بوسائد هوائية أمامية مزدوجة لكل من السائق والراكب الأمامي وهي عنصر أساسي في نظام أمان السيارة، مصممة لحماية الركاب في حالة حدوث تصادم." }
                        ]
                    },
                    interior: {
                        tag: "المقصورة", title: "راحة من الدرجة الأولى في كل رحلة", desc: "يوفر تصميم مقصورة بايك U5 PLUS مزيجاً من التكنولوجيا الحديثة والراحة، ويتميز بمقصورة واسعة بمواد عالية الجودة وتصميم مدروس بعناية.", items: [
                            { title: "شاشة تحكم 12.3 بوصة", desc: "تم تجهيز U5 بشاشة تحكم حديثة مقاس 12.3 بوصة، وهي جوهر التكنولوجيا المتقدمة داخل السيارة. تندمج هذه الشاشة الكبيرة عالية الدقة بسلاسة مع لوحة قيادة السيارة، مما يوفر كلاً من الوظائف والجماليات الحديثة." },
                            { title: "عداد LCD 7 بوصة", desc: "إنها شاشة رقمية متقدمة تحسن تجربة القيادة من خلال توفير معلومات واضحة وفي الوقت المناسب حول أداء السيارة وحالتها، مما يسمح للسائق بالوصول بسرعة وسهولة إلى المعلومات المهمة." }
                        ]
                    },
                    specs: { tag: "البيانات الفنية", title: "المواصفات" },
                    footer: { title: "قد بذكاء", desc: "اكتشف السيدان المثالية للعائلة العصرية.", btn: "إحجز تجربة قيادة" }
                },
                specs: [
                    { label: 'المحرك', value: '1.5 لتر', sub: 'CVT' },
                    { label: 'صافي القوة', value: '83 كيلوواط', sub: '103 حصان' },
                    { label: 'العزم الأقصى', value: '142 نيوتن متر', sub: '@ 3800-4800 دورة/دقيقة' },
                    { label: 'ناقل الحركة', value: 'CVT', sub: 'متغير مستمر' },
                    { label: 'الأبعاد', value: '4660 مم', sub: 'الطول' },
                    { label: 'قاعدة العجلات', value: '2670 مم', sub: 'مقصورة واسعة' },
                    { label: 'استهلاك الوقود', value: '5.7 لتر', sub: 'لكل 100 كم' },
                    { label: 'السلامة', value: '5 نجوم', sub: 'تصنيف C-NCAP' }
                ]
            }
        },
        about: {
            title: "عن بايك",
            subtitle: "بناء سيارات تلهم وتيبتكر وتدوم لأكثر من ستة عقود",
            stats: [
                { value: '+60', label: 'عاماً من التميز' },
                { value: '+80', label: 'بلداً حول العالم' },
                { value: '+100K', label: 'موظف' },
                { value: 'أفضل 200', label: 'فورتشن جلوبال 500' },
            ],
            missionTitle: "مهمتنا",
            missionText: "إبداع سيارات مبتكرة ومستدامة وعالية الجودة تعزز حياة عملائنا في جميع أنحاء العالم. نحن ملتزمون بالتميز في التصميم والهندسة وخدمة العملاء، بينما نقود انتقال صناعة السيارات إلى مستقبل مستدام.",
            visionTitle: "الرؤية",
            visionText: "أن نكون رائداً عالمياً في حلول التنقل الذكية والمتصلة والمستدامة. نتخيل مستقبلاً حيث لا تقوم سياراتنا بنقل الأشخاص فحسب، بل تساهم أيضاً في مدن أنظف وطرق أكثر أماناً وعالم أكثر اتصالاً.",
            timelineTitle: "رحلتنا",
            timeline: [
                { year: '1958', event: 'تأسيس بايك', description: 'تأسست باسم مصنع بكين للسيارات' },
                { year: '1984', event: 'أول مشروع مشترك', description: 'شراكة مع AMC لإنتاج جيب شيروكي' },
                { year: '2010', event: 'تشكيل مجموعة بايك', description: 'إعادة الهيكلة إلى كيان مؤسسي حديث' },
                { year: '2018', event: 'التوسع العالمي', description: 'دخول أكثر من 50 سوقاً دولياً' },
                { year: '2023', event: 'المستقبل الكهربائي', description: 'إطلاق مجموعة شاملة من السيارات الكهربائية' },
            ]
        },
        overview: {
            whoWeAreTitle: "معلومات عن",
            statsGrid: [
                { val: "1958", label: "تأسست في", pos: "bottom" },
                { val: "أفضل 5", label: "مجموعات سيارات صينية", pos: "top" },
                { val: "34 مليون", label: "الإنتاج", pos: "bottom" },
                { val: "480 مليار", label: "إيرادات التشغيل", pos: "top" },
                { val: "353.68 مليار", label: "قيمة العلامة التجارية", pos: "bottom" },
                { val: "192", label: "فورتشن جلوبال 500", pos: "top" },
                { val: "9.98%", label: "أسهم في دايملر AG", pos: "bottom" },
            ],
            awardsTitle: "الجوائز",
            awardsText: "من خلال أكثر من 60 عاماً من التطوير، تراكمت لدى بايك خبرة واسعة في البحث والتطوير في مجال السيارات، وحققت العديد من الجوائز في مجالات مثل براءات الاختراع التكنولوجية، ونقل الحركة، والهيكل، وهيكل الجسم، والقيادة الذكية، والتحكم في المقالصورة، والصحة والسلامة، والمواد الهندسية، والجودة والسمعة، وحظيت بإشادة بالإجماع من المؤسسات الموثوقة.",
            topGearTitle: "توب جير",
            topGearText: "حصلت 'بايك X55' مرة أخرى على جائزة 'اختيار القراء لعام 2023' من توب جير، مما يمثل المرة الثانية خلال عام التي تحتل فيها 'بايك X55' الصدارة في صناعة السيارات بجنوب إفريقيا.",
            productionBases: [
                {
                    title: "مصنع بكين",
                    image: "/assets/images/about/overview/new/BEIJING.webp",
                    stats: [
                        { label: "وقت بدء الإنتاج", value: "2015" },
                        { label: "مساحة الأرض", value: "540,000 متر مربع" },
                        { label: "القدرة المخططة", value: "100,000 وحدة / سنة" },
                        { label: "الموديلات قيد الإنتاج", value: "BJ40 / F40 / BJ60 / BJ80" }
                    ]
                },
                {
                    title: "مصنع تشنجيانغ",
                    image: "/assets/images/about/overview/new/ZHENJIANG.webp",
                    stats: [
                        { label: "وقت بدء الإنتاج", value: "2013" },
                        { label: "مساحة الأرض", value: "400,000 متر مربع" },
                        { label: "القدرة المخططة", value: "150,000 وحدة / سنة" },
                        { label: "الموديلات قيد الإنتاج", value: "BJ30" }
                    ]
                }
            ]
        },
        history: {
            title: "التاريخ",
            pageTitle: "بايك",
            timeline: [
                { year: '2022', title: 'تم اختيارها في قائمة فورتشن جلوبال 500 لمدة عشر سنوات متتالية', image: '/assets/images/about/history/fortune500.jpeg' },
                { year: '2021', title: 'رخصت بايك التكنولوجيا والملكية الفكرية ذات الصلة لمنصة BE21 لشركة Steyr USA LLC.', image: '/assets/images/about/history/baic-licensed.jpeg' },
                { year: '2020', title: 'عززت فوتون تعاونها مع دايملر، وتم توطين شاحنات مرسيدس-بنز الثقيلة رسمياً.', image: '/assets/images/about/history/foton-deepened.png' },
                { year: '2018', title: 'وقعت مجموعة بايك وماجنا اتفاقية تعاون استراتيجي لإنشاء مشروع مشترك وبناء قاعدة بحث وتطوير وتصنيع للسيارات الكهربائية الراقية.', image: '/assets/images/about/history/magna.jpeg' },
                { year: '2017', title: 'تم استخدام BJ80 مرة أخرى كسيارة للرئيس في العرض العسكري بمناسبة الذكرى التسعين لتأسيس جيش التحرير الشعبي.', image: '/assets/images/about/history/military-parade.jpeg' },
                { year: '2016', title: 'تم الاستحواذ على حصة 35% في فوجيان بنز.', image: '/assets/images/about/history/benz.jpeg' },
                { year: '2013', title: 'تم تأسيس بايك الدولية رسمياً.', image: '/assets/images/about/history/baic-intl.jpeg' },
                { year: '2010', title: 'تم الاستحواذ بنجاح على 100% من أسهم Inalfa.', image: '/assets/images/about/history/inalfa.jpeg' },
                { year: '2009', title: 'نجحت مجموعة بايك في الاستحواذ على حقوق الملكية الفكرية لشركة ساب السويدية.', image: '/assets/images/about/history/saab.jpeg' },
                { year: '2003', title: 'وقعت مجموعة بايك ودايملر كرايسلر اتفاقية إطار تعاون استراتيجي.', image: '/assets/images/about/history/2003.jpeg' },
                { year: '2002', title: 'وقعت مجموعة بايك وشركة هيونداي موتور تعاوناً استراتيجياً شاملاً.', image: '/assets/images/about/history/2002.jpeg' },
                { year: '1996', title: 'تأسست شركة فوتون موتور المحدودة، والتي تحتل المرتبة الأولى في العالم من حيث مبيعات المركبات التجارية.', image: '/assets/images/about/history/1996.jpeg' },
                { year: '1983', title: 'تم تأسيس مشروع بكين جيب المشترك، وهو أول مشروع مشترك صيني أجنبي لتصنيع السيارات الكاملة.', image: '/assets/images/about/history/1983.jpeg' },
                { year: '1966', title: 'تم إدخال سيارة BJ212 للطرق الوعرة التي طورتها بايك بشكل مستقل في الإنتاج رسمياً.', image: '/assets/images/about/history/1966.jpeg' },
                { year: '1958', title: 'ولدت "جينغ قانغ شان" كأول سيارة السيدان لبايك.', image: '/assets/images/about/history/1958.jpeg' }
            ]
        },
        vision: {
            title: "الرؤية",
            subtitle: "رؤية العلامة التجارية",
            banners: [
                {
                    subtitle: 'مكانة العلامة التجارية',
                    title: 'جعل الحياة أكثر إشراقاً',
                },
                {
                    subtitle: 'شعار العلامة التجارية',
                    title: 'دائماً معك',
                },
                {
                    subtitle: 'القيمة الجوهرية',
                    title: 'موثوق',
                },
                {
                    subtitle: 'سمات العلامة التجارية',
                    title: 'رعاية وثقة وشخصية',
                }
            ]
        },
        afterSales: {
            integrity: {
                title: "الموثوقية والنزاهة",
                desc: "استخدام قطع غيار أصلية مع أسعار مناسبة وتنافسية في جميع مراحل الخدمة."
            },
            warm: {
                title: "الاهتمام والراحة",
                desc: "شبكة وكلاء مريحة وسهلة الوصول، مع خدمات صيانة وإصلاح سريعة وفعّالة لضمان جاهزية المركبة في جميع الأوقات."
            },
            care: {
                title: "العناية",
                desc: "تركيز كامل على احتياجات العملاء مع خدمات ما بعد البيع المخصصة لضمان تجربة تملك موثوقة ومستدامة"
            },
            professional: {
                title: "الاحترافية",
                desc: "مرافق صيانة متطورة وفرق فنية متخصصة ومدربة"
            }
        },

        careers: {
            hero: {
                title: "الوظائف",
                subtitle: "شكّل مستقبل تكنولوجيا السيارات معنا."
            },
            generalApp: {
                title: "طلب عام",
                desc: "لا تجد دوراً محدداً يناسبك؟ أرسل طلبك العام هنا، وسنتصل بك عند توفر منصب مناسب."
            },
            form: {
                title: "اللقب",
                firstName: "الاسم الأول",
                lastName: "اسم العائلة",
                email: "البريد الإلكتروني",
                phone: "رقم الهاتف",
                nationality: "الدولة",
                position: "المنصب المطلوب",
                cv: "تحميل السيرة الذاتية (PDF/DOC, Max 5MB)",
                chooseFile: "اختار الملف",
                noFile: "لم يتم اختيار ملف",
                message: "الرسالة / خطاب التغطية",
                submit: "إرسال الطلب",
                submitting: "جار الإرسال...",
                placeholders: {
                    select: "اختر",
                    firstName: "الاسم الأول",
                    lastName: "اسم العائلة",
                    email: "example@email.com",
                    phone: "91234567",
                    nationality: "اختر الدولة",
                    position: "مثال: مسؤول مبيعات",
                    message: "أخبرنا لماذا ستكون مناسباً..."
                },
                options: {
                    mr: "السيد",
                    ms: "الآنسة",
                    mrs: "السيدة",
                    uae: "الإمارات",
                    other: "أخرى"
                }
            },
            whyJoin: {
                title: "لماذا تنضم إلى بايك؟",
                growth: {
                    title: "فرص النمو",
                    desc: "نستثمر في موظفينا. من برامج التدريب إلى التوجيه، نساعدك على بناء مسار مهني، وليس مجرد وظيفة."
                },
                innovation: {
                    title: "الابتكار",
                    desc: "اعمل مع أحدث تقنيات السيارات وكن جزءاً من علامة تجارية تحدد مستقبل التنقل."
                },
                culture: {
                    title: "ثقافة شاملة",
                    desc: "انضم إلى فريق متنوع حيث كل صوت مهم. نؤمن بالتعاون والاحترام والنجاح المشترك."
                }
            }
        },
        common: {
            threeSixtyView: "رؤية محيطية شاملة 360 درجة",
            capitalBeautyRedefined: "إعادة تعريف الأناقة الحضرية بمعايير تصميم متطورة.",
            offRoadVehicle: "مركبة الطرق الوعرة",
        },
        nextSteps: {
            title: "خطواتك التالية",
            requestBrochure: "طلب كتالوج",
            findShowroom: "العثور على صالة العرض",
            bookTestDrive: "حجز تجربة قيادة",
            requestQuote: "طلب عرض تسعيرة",
            callTollFree: "الاتصال بالرقم المجاني",
            whatsapp: "تواصل معنا عبر الواتس اب"
        },
        nav: {
            models: 'الطرازت',
            history: 'التاريخ',
            about: 'معلومات عن',
            newsroom: 'الأخبار',
            connect: 'الإتصال',
            service: 'الخدمة',
            gallery: 'معرض الالصور',
            worldwide: 'العالمية',
            testDrive: 'اختبار القيادة',
            explore: 'استكشف المزيد',
            all: 'الجميع',
            offRoad: 'الدفع الرباعي',
            suv: 'سيارات SUV',
            sedan: 'السيدان',
            power: 'القوة',
            torque: 'عزم الدوران',
            wheelbase: 'قاعدة العجلات',
            showrooms_service: 'صالات العرض ومراكز الخدمة ',
            requestQuote: 'طلب عرض تسعيرة',
            bookTestDrive: 'حجز تجربة قيادة',
            requestCatalogue: 'طلب كتالوج',
            categories: 'الفئات',
            baicHistory: 'تاريخ بايك',
            offRoadHistory: 'الطرق الوعرة',
            baicAbout: 'بايك',
            ggs: 'رمال الخليج الكبرى',
            vision: 'الرؤية',
            afterSales: 'خدمات مابعد البيع',
            contactUs: 'تواصل معنا',
            careers: 'الوظائف',
            showroom: 'صالات العرض',
            serviceCenter: 'مركز الخدمة'
        },
        quickLinks: {
            title: "روابط سريعة",
            contact: "تواصل معنا",
            testDrive: "اختبار القيادة",
            service: "الخدمات",
            careers: "الوظائف"
        },
        footer: {
            companyInfo: 'الموزع الرسمي في سلطنة عمان',
            quickLinks: 'روابط سريعة',
            services: 'الخدمات',
            contactUs: 'تواصل معنا',
            disclaimer: 'إخلاء المسؤولية: لا تعتبر الصور المعروضة تمثيلاً مطابقاً للواقع. قد تختلف المركبات والمزايا المعروضة عن الطرازات المتوفرة فعلياً في منطقتك. كما تخضع المواصفات والتجهيزات للتغيير دون إشعار مسبق.',
            rights: 'جميع الحقوق محفوظة.',
            links: {
                models: 'الطرازت',
                history: 'التاريخ',
                aboutBaic: 'عن بايك',
                ggs: 'رمال الخليج الكبرى',
                vision: 'الرؤية',
                afterSales: 'خدمات مابعد البيع',
                careers: 'الوظائف',
                contact: 'تواصل معنا',
                privacyPolicy: 'سياسة الخصوصية',
                termsConditions: 'الشروط والأحكام',
                showroom: 'صالات العرض',
                serviceCenter: 'مركز الخدمة',
                bookService: 'حجز خدمة',
                warranty: 'الضمان'
            },
            contact: {
                call: 'اتصل',
                whatsapp: 'واتساب',
                address: 'صندوق بريد 1642، الرمز البريدي 131، القرم، مسقط، سلطنة عمان'
            }
        },
        testDrive: {
            hero: {
                subtitle: "اختبر التميز",
                title: "اختبار القيادة",
                desc: "اكتشف الأداء الاستثنائي والراحة التي توفرها سيارات بايك. احجز تجربة قيادة حصرية اليوم."
            },
            steps: {
                step1: { number: "01", title: "اختر الطراز", desc: "اختر سيارتك المفضلة", sedan: "السيدان", suv: "الطرق الوعرة" },
                step2: { number: "02", title: "تفاصيلك", desc: "املأ معلومات الاتصال الخاصة بك" }
            },
            form: {
                title: "اللقب",
                firstName: "الاسم الأول",
                lastName: "اسم العائلة",
                email: "البريد الإلكتروني",
                phone: "رقم الاتصال",
                location: "موقعك",
                date: "التاريخ المفضل",
                time: "الوقت المفضل",
                message: "رسالة",
                privacy: "أوافق على بيان الخصوصية وأفهم كيف سيتم معالجة بياناتي الشخصية.",
                submit: "إرسال",
                placeholders: {
                    selectTitle: "السيد",
                    phone: "مثلاً 12345678",
                    time: "أي وقت",
                    pickDate: "اختر تاريخاً"
                },
                timeOptions: {
                    anytime: "أي وقت",
                    morning: "صباحاً",
                    afternoon: "بعد الظهر",
                    evening: "مساءً"
                }
            },
            bookNow: "احجز الآن"
        },
        contact: {
            title: "تواصل معنا",
            cards: {
                phone: "اتصل",
                whatsapp: "واتساب",
                email: "البريد الإلكتروني",
                location: "الموقع",
                locationText: "صندوق بريد 1642، الرمز البريدي 131، القرم، مسقط، سلطنة عمان"
            },
            form: {
                title: "شكراً لدعمكم لشركة بايك،",
                subtitle: "يرجى ترك معلومات الاتصال الخاصة بك وأسئلتك، وسنقوم بترتيب متخصصين للاتصال بك",
                fields: {
                    title: "اللقب",
                    firstName: "الاسم الأول",
                    lastName: "اسم العائلة",
                    phone: "رقم الهاتف",
                    nationality: "الجنسية",
                    email: "البريد الإلكتروني",
                    mediaName: "اسم الوسيلة الإعلامية",
                    description: "الوصف",
                    submit: "إرسال",
                    iAmNotRobot: "أنا لست روبوت",
                    mr: "السيد",
                    ms: "الآنسة",
                    mrs: "السيدة",
                    uae: "الإمارات",
                    saudi: "السعودية",
                    other: "أخرى"
                },
                placeholders: {
                    select: "يرجى الاختيار",
                    firstName: "يرجى إدخال الاسم الأول",
                    lastName: "يرجى إدخال اسم العائلة",
                    phone: "يرجى إدخال رقم الهاتف",
                    email: "يرجى إدخال البريد الإلكتروني",
                    description: "يرجى إدخال الوصف"
                },
                toast: {
                    sent: "تم إرسال الرسالة!",
                    desc: "سنعاود الاتصال بك خلال 24 ساعة."
                },
                submit: "إرسال"
            }
        },
        newsroom: {
            title: "الأخبار",
            subtitle: "آخر التحديثات والإعلانات من بايك",
            searchPlaceholder: "البحث في الأخبار...",
            readMore: "اقرأ المزيد",
            categories: {
                all: "الجميع",
                productLaunch: "إطلاق منتج",
                corporate: "شركات",
                technology: "تكنولوجيا",
                sustainability: "استدامة"
            },
            news: [
                {
                    title: 'بايك تحتل المرتبة 192 في قائمة فورتشن جلوبال 500',
                    category: 'شركات',
                    date: '15 يناير 2025',
                    excerpt: 'حققت مجموعة بايك تصنيفاً مرموقاً في قائمة فورتشن جلوبال 500، مما يبرز التزامنا بالتميز والابتكار في صناعة السيارات.',
                },
                {
                    title: 'إطلاق منصة تكنولوجيا بايك الذكية',
                    category: 'تكنولوجيا',
                    date: '10 ديسمبر 2024',
                    excerpt: 'تقديم أحدث تقنيات المركبات الذكية التي تعيد تعريف تجربة القيادة مع ميزات مدعومة بالذكاء الاصطناعي وخدمات متصلة.',
                },
                {
                    title: 'افتتاح مصنع جديد في الإمارات',
                    category: 'شركات',
                    date: '22 نوفمبر 2024',
                    excerpt: 'بايك تفتتح منشأة تصنيع حديثة تضم روبوتات متقدمة وعمليات إنتاج مستدامة.',
                },
                {
                    title: 'BJ60 تفوز بجائزة أفضل سيارة الطرق الوعرة',
                    category: 'إطلاق منتج',
                    date: '8 أكتوبر 2024',
                    excerpt: 'تم الاعتراف بـ BJ60 كأفضل سيارة الطرق الوعرة لهذا العام من قبل الرابطة الدولية لصحافة السيارات.',
                },
                {
                    title: 'بايك تلتزم بالحياد الكربوني بحلول 2030',
                    category: 'استدامة',
                    date: '15 سبتمبر 2024',
                    excerpt: 'نعلن عن أهداف بيئية طموحة تشمل الحياد الكربوني عبر جميع العمليات بحلول عام 2030.',
                },
                {
                    title: 'شراكة مع شركة تكنولوجيا رائدة',
                    category: 'تكنولوجيا',
                    date: '3 أغسطس 2024',
                    excerpt: 'شراكة استراتيجية لتطوير أنظمة القيادة الذاتية من الجيل التالي وتكامل الذكاء الاصطناعي.',
                },
            ]
        },
        service: {
            title: "الخدمة",
            intro: "هل تحتاج إلى يد المساعدة؟ اختر خدمة.",
            cards: {
                booking: {
                    title: "الحجز",
                    desc: "هل حان موعد خدمة سيارتك؟ تخطى طوابير الانتظار في مراكز الخدمة وحدد موعدك اليوم!",
                    btn: "حجز موعد"
                },
                feedback: {
                    title: "الملاحظات",
                    desc: "اتصل بمكتب الخدمة للحصول على مساعدة في طلبك، أسئلتك ومشاكلك. احصل على المساعدة عبر الهاتف أو البريد الإلكتروني.",
                    btn: "إرسال ملاحظات"
                },
                recall: {
                    tag: "تحديث السلامة",
                    title: "إشعار استدعاء بايك X7",
                    subtitle: "(موديلات 2022-2023)",
                    desc: "يتم استدعاء بعض موديلات بايك X7 بسبب مشكلة فنية في صندوق المصاهر الكهربائية.",
                    btn: "شاهد المزيد"
                }
            }
        },
        worldwide: {
            title: "عالميًا",
            subtitle: "تواجُد بايك في جميع أنحاء العالم",
            stats: {
                countries: "بلدان",
                dealerships: "وكلاء",
                serviceCenters: "مراكز خدمة",
                customers: "عملاء"
            },
            regions: {
                middleEast: "الشرق الأوسط",
                asia: "آسيا",
                africa: "أفريقيا",
                europe: "أوروبا",
                americas: "الأمريكيتان"
            },
            findDealer: "ابحث عن وكيل",
            availableIn: "متوفر في",
            cantFind: {
                title: "لا تستطيع العثور على موقعك؟",
                desc: "نحن نوسع شبكتنا العالمية باستمرار. تواصل معنا للعثور على أقرب وكيل أو مركز خدمة بايك.",
                btn: "الاتصال بالدعم العالمي"
            },
            locations: {
                middleEast: [
                    { country: 'الإمارات العربية المتحدة', cities: ['دبي', 'أبو ظبي', 'الشارقة'] },
                    { country: 'المملكة العربية السعودية', cities: ['الرياض', 'جدة', 'الدمام'] },
                    { country: 'قطر', cities: ['الدوحة'] }
                ],
                asia: [
                    { country: 'الصين', cities: ['بكين', 'شنغهاي', 'غوانغتشو'] },
                    { country: 'تايلاند', cities: ['بانكوك', 'باتايا'] }
                ],
                africa: [
                    { country: 'جنوب أفريقيا', cities: ['جوهانسبرغ', 'كيب تاون'] },
                    { country: 'مصر', cities: ['القاهرة', 'الإسكندرية'] }
                ],
                europe: [
                    { country: 'ألمانيا', cities: ['برلين', 'ميونخ'] }
                ],
                americas: [
                    { country: 'المكسيك', cities: ['مكسيكو سيتي', 'مونتيري'] }
                ]
            }
        },
        gallery: {
            tabs: {
                all: "الجميع",
                videos: "فيديوهات",
                images: "الصور"
            },
            categories: {
                corporate: "شركات",
                models: "طرازات",
                offRoad: "الطرق الوعرة",
                interior: "داخلية",
            },
            filterModels: {
                all: "كل الموديلات",
                bj30Hybrid: "BJ30 هايبرد",
                bj40Honor: "BJ40 هونور",
                bj40Pro: "BJ40 برو",
                u5Plus: "U5 بلس"
            }
        },
        bookService: {
            sidebar: {
                title: "حجز الخدمة",
                heading: "جدولة خدمتك",
                desc: "اختبر رعاية متميزة لسيارتك. احجز موعدك في بضع خطوات بسيطة.",
                steps: {
                    location: { title: "اختر الموقع", desc: "اختر أقرب مركز خدمة معتمد لك." },
                    date: { title: "اختر التاريخ", desc: "حدد وقتاً مناسباً لزيارتك." },
                    vehicle: { title: "تفاصيل السيارة", desc: "أخبرنا عن طراز بايك الخاص بك." }
                }
            },
            form: {
                location: {
                    title: "إعدادات الموقع",
                    emirate: "الإمارة",
                    serviceCenter: "مركز الخدمة"
                },
                date: {
                    title: "التاريخ والتفضيلات",
                    time: "الوقت المفضل",
                    note: "سيقوم مستشارو الخدمة بتأكيد توفر الوقت المحدد بعد الحجز."
                },
                details: {
                    title: "المعلومات الشخصية والمركبة",
                    vehicleInfo: "معلومات السيارة",
                    model: "الموديل",
                    year: "السنة",
                    mileage: "المسافة المقطوعة الحالية",
                    licensePlate: "رقم اللوحة",
                    contactInfo: "معلومات الاتصال",
                    title: "اللقب",
                    firstName: "الاسم الأول",
                    lastName: "اسم العائلة",
                    email: "البريد الإلكتروني",
                    phone: "رقم الهاتف"
                },
                submit: "تأكيد الحجز",
                agreement: "عند الحجز، فإنك توافق على"
            },
            placeholders: {
                selectModel: "اختر الموديل",
                selectYear: "اختر السنة",
                mileage: "مثلاً 15,000 كم",
                license: "مثلاً أ 12345"
            }
        },

        offRoad: {
            banner: { subtitle: "التاريخ", title: "الطرق الوعرة" },
            engineering: {
                title: "القدرة على التحقق الهندسي",
                p1: "تم إنشاء أنظمة تحقق كاملة تغطي المكونات والأنظمة والمركبات الكاملة، مع الحصول على شهادة CNAS. تتميز ورشة الإنتاج التجريبي الاحترافية لدينا بعملية تحقق شاملة، تنتج ما يصل إلى 300 نوع تجريبي ونماذج أولية سنوياً.",
                p2: "تتيح منصة التحليل الذكي للبيانات الضخمة لدينا استخراجاً سريعاً ودقيقاً للمعلومات القيمة من البيانات الضخمة، والتي تم تطبيقها بنجاح عبر عمليات البحث والتطوير المختلفة للمركبات."
            },
            production: {
                title: "القدرة على إنتاج المركبات",
                desc: "تبلغ مساحة مصنع سيارات الطرق الوعرة الإجمالية 346,000 متر مربع وتبلغ طاقته الإنتاجية السنوية 100,000 سيارة، وفاز بلقب المصنع الأخضر الوطني، \"جائزة التميز في مسابقة المصانع الرقمية الأفضل في الصين\"."
            },
            reliability: {
                title: "موثوقية تصميم عالية",
                desc: "طور مصنع سيارات الطرق الوعرة أيضاً 28 طريقة لتحليل واستخراج أطياف الحمل في ظل ظروف العمل القصوى والنموذجية، والجمع بين الأحمال الديناميكية والثابتة. بالإضافة إلى ذلك، ابتكرت 35 هيكلاً عالي الموثوقية، وأنشأت اختبارات افتراضية ومادية باستخدام منصة اختبار متعددة المستويات. زادت اختبارات قاعدة سيارات الطرق الوعرة الأساسية بشكل كبير متوسط المسافة المقطوعة بين الأعطال من 1,200 كم إلى 7,536 كم."
            },
            timeline: {
                t1: "البداية", t2: "إطلاق BJ212", t3: "تطور", t4: "عصر جديد", t5: "ابتكار", t6: "المسرح العالمي", t7: "توسع", t8: "تحديث", t9: "إطلاق BJ40", t10: "المستقبل"
            }
        },
        innovation: {
            hero: {
                title: "الابتكار",
                subtitle: "قيادة المستقبل بأحدث التقنيات والحلول المستدامة"
            },
            grid: {
                title: "ابتكاراتنا",
                desc: "بايك في طليعة الابتكار في مجال السيارات، حيث تطور تقنيات تعيد تعريف التنقل والاستدامة.",
                items: [
                    { title: "نقل الحركة الكهربائية", desc: "الجيل القادم من مجموعات نقل الحركة الكهربائية والهجينة التي تقدم أداء استثنائياً بدون انبعاثات." },
                    { title: "السلامة المتقدمة", desc: "أنظمة سلامة شاملة تشمل الكبح الطارئ المستقل، والمساعدة في الحفاظ على المسار، والمراقبة بزاوية 360 درجة." },
                    { title: "تكامل الذكاء الاصطناعي", desc: "مساعدة القيادة المدعومة بالذكاء الاصطناعي والصيانة التنبؤية لتعزيز الموثوقية." },
                    { title: "تكنولوجيا البطاريات", desc: "تكنولوجيا بطاريات متطورة بمدى ممتد وقدرات شحن سريع." },
                    { title: "السيارة المتصلة", desc: "اتصال سلس مع تكامل المنزل الذكي، والتحديثات عبر الهواء، والتحكم في السيارة عن بعد." },
                    { title: "القيادة الذاتية", desc: "أنظمة مساعدة السائق المتقدمة تمهد الطريق لقدرات القيادة الذاتية الكاملة." }
                ]
            },
            research: {
                title: "البحث والتطوير",
                desc: "تضم مرافق البحث والتطوير الحديثة لدينا بعضاً من ألمع العقول في هندسة السيارات، الذين يعملون بلا كلل لدفع حدود الممكن.",
                list: [
                    "أكثر من 2000 مهندس وباحث",
                    "مرافق اختبار متعددة حول العالم",
                    "شراكات مع شركات تكنولوجيا رائدة",
                    "استثمار أكثر من 2 مليار دولار سنوياً في البحث والتطوير"
                ]
            }
        },
        contact: {
            title: "تواصل معنا",
            cards: {
                phone: "هاتف",
                whatsapp: "واتساب",
                locationText: "اعثر علينا على خرائط جوجل"
            },
            form: {
                title: "تواصل معنا",
                subtitle: "نود أن نستمع منك. يرجى ملء هذا النموذج.",
                toast: {
                    sent: "تم إرسال الرسالة",
                    desc: "لقد استلمنا رسالتك وسنتصل بك قريباً."
                },
                fields: {
                    title: "اللقب",
                    mr: "السيد",
                    ms: "الآنسة",
                    mrs: "السيدة",
                    firstName: "الاسم الأول",
                    lastName: "اسم العائلة",
                    phone: "رقم الهاتف",
                    nationality: "الدولة",
                    uae: "الإمارات",
                    saudi: "السعودية",
                    other: "أخرى",
                    email: "البريد الإلكتروني",
                    mediaName: "الرسالة",
                    iAmNotRobot: "أنا لست برنامج روبوت",
                    submit: "إرسال",
                    privacy: "أوافق على بيان الخصوصية وأفهم كيف سيتم معالجة بياناتي الشخصية."
                },
                placeholders: {
                    select: "اختر...",
                    firstName: "أدخل اسمك الأول",
                    lastName: "أدخل اسم العائلة",
                    phone: "أدخل رقم هاتفك",
                    email: "أدخل بريدك الإلكتروني",
                    description: "كيف يمكننا مساعدتك؟"
                }
            }
        }
    }
};
